
import { watch, provide, ref, reactive } from 'vue';
import { setObj } from "@/utils/object-method";
import { GetBeautify } from '@/api/designer-api';
import { finArrChildrenValue } from '@/utils/func.js';
import componentOptions from '@/components/options';
import { MessagePlugin } from 'tdesign-vue-next';
import { defaultTheme } from '@/components/beautify';
import { ComponentTreeBar, Suspension } from '@/views/viewsFunction/designerMethods'

let buttonGroupEventObject = ref(null)
let pageEventObject = ref(null)
let beautifyList = ref([]) // 美化列表

export default (props = {}) => {

    /**
     * 键盘触发DEL按键执行删除组件操作
     */
    const addDeleteKeyListener = () => {

        const handleDelete = (event) => {
            if (event.key === 'Delete' && typeof delCurrCpt === 'function') {
                delCurrCpt();
            }
        };

        // 添加事件监听器并保存引用
        document.addEventListener('keydown', handleDelete, { passive: true });

    };

    // 批量删除
    const delCurrCpt = (e) => {
        if (e?.key == 'Backspace') return false
        if (!props.selectedComponents.value.length) return false


        // 组合选项卡隐藏显示
        CombinationTab.onTouchCombintionTab()
        // 九宫格隐藏显示
        CombinationNg.onTouchCombintionTab()
        props.inStack('add', props.selectedComponents.value)
        props.inStack('del', props.selectedComponents.value)

        props.selectedComponents.value.forEach((item, index) => {
            let cacheCompIndex = props.cacheComponents.findIndex(comp => comp.id == item.id)
            let cacheComp = props.cacheComponents.find(comp => comp.id == item.id)


            if (!cacheComp) {
                return
            }

            // 去除选项卡组合控件删除功能
            // if (CombinationTab.stopTabGroupComps(item, props.selectedComponents.value, props.cacheComponents)) {
            //     return
            // }



            if (CombinationTab.delete({ deleteItem: item, cacheComponents: props.cacheComponents })) return false
            CombinationNg.delete(item)

            cacheComp.groupCompName && onGroup.cancelGroup('delete')

            ButtonGroup.watchButtonGroup(item, props.cacheComponents)
            props.cacheComponents.splice(cacheCompIndex, 1);

        })
        ComponentTreeBar.init({ cacheComponents: props.cacheComponents })
        props.currentCptIndex.value = -1;
        props.contextMenu.show = false;//关闭右键菜单
        props.outBlur()
    }

    const initLookHideComp = () => {
        props.cacheComponents.forEach(item => {
            if (item.cptLookShow) {
                props.editShowHideComponents.push(item)
            }
        })
    }
    // 批量设置组件显示隐藏
    const setCompShowHideAll = (type, cacheChoices) => {
        // 选中参数传入后修改选中对象
        if (cacheChoices) {
            cacheChoices.forEach((item, id) => {
                props.cacheChoices[id] = item
            })
        }

        // 选中id组
        let selectCompIds = Object.values(props.cacheChoices).map(x => x.id) || []
        if (type == 'hide') {
            props.cacheComponents.forEach((component, index) => {
                if (component.id === selectCompIds[0]) {
                    // 找到匹配的组件后添加ref属性
                    // console.log(props.refMap[selectCompIds[0]].getValue(),'props.refMap[selectCompIds[0]]')
                    // props.cacheComponents[index].cptOption.attribute.ref = JSON.stringify(props.refMap[selectCompIds[0]]);
                    console.log(props.refMap[selectCompIds[0]], 'props.refMap[selectCompIds[0]]');
                    let compFuncGetValue = props.refMap[selectCompIds[0]]?.getValue
                    if (compFuncGetValue) {
                        props.cacheComponents[index].cptOption.attribute.refGetValue = props.refMap[selectCompIds[0]]?.getValue();
                    }
                }
            });
        }

        CombinationTab.onTouchCombintionTab()
        CombinationNg.onTouchCombintionTab()

        Object.values(props.cacheChoices).forEach((item, index) => {
            let shCompIndex = props.editShowHideComponents.findIndex(sh => sh.id == item.id)
            let shCompId = props.editShowHideComponents.map(x => x.id).find(sh => sh == item.id)
            if (type == 'hide') {
                if (!shCompId) {
                    if (!props.designData.lookHideComp) {
                        onGroup.clearGroupBorder()
                        item.cptShow = false
                    }
                    item.cptLookShow = true
                    props.editShowHideComponents.push(item)
                } else {
                    item.cptLookShow = true
                }
            } else if (type == 'show') {
                item.cptLookShow = false
                item.cptShow = true
                if (shCompIndex != -1) props.editShowHideComponents.splice(shCompIndex, 1)
            }
        })


        props.currentCptIndex.value = -1;
        props.contextMenu.show = false;//关闭右键菜单
        props.outBlur()


    }
    // 查看已隐藏的组件
    const setLookHideComp = (value) => {
        const tabTitle = props.cacheComponents.find(x => x?.cptType === 'combination')

        props.editShowHideComponents.forEach(item => {
            item.cptShow = value


            // console.log(hasComp, inComp)
            // if(hasComp && inComp) {

            // } else if (!hasComp && !inComp) {
            //     item.cptShow = value

            // }

        })

        onGroup.clearGroupBorder()
        // CombinationTab.setTabContentShowHide()


        props.designData.lookHideComp = value
        setObj(props.cacheChoices, {})
        props.outBlur()
    }





    // 在大屏中设置排列
    const clickPoistion = (type) => {
        const configBar = props.refMap['configBar']
        configBar.clickPoistion(type)
    }

    // 设置大屏中排列的位置
    const initLotsizePoistion = () => {
        const selectComps = Object.values(props.cacheChoices)
        selectComps.forEach(item => {
            item.divWidth = props.refMap['div' + item.id]?.clientWidth
            item.divHeight = props.refMap['div' + item.id]?.clientHeight
        })
        setLotsizePoistion()

        // watch(props.selectedComponents.value, value => {
        //     setLotsizePoistion()
        // })
    }
    const setLotsizePoistion = () => {
        const lotsizePopup = props.refMap['lotsize-popup']
        if (!lotsizePopup) {
            return
        }

        let maxR = getPoistion.getRightMax(props.selectedComponents.value)

        let maxT = getPoistion.getTopMax(props.selectedComponents.value)

        lotsizePopup.style.position = 'absolute'
        lotsizePopup.style.left = maxR.cptX + 100 + 'px'
        lotsizePopup.style.top = maxT.cptY - 70 + 'px'
    }

    const getPoistion = {
        getTopMax: (list) => {
            if (!list.length) return 0
            return list.reduce((pre, next) => {
                return pre.cptY < next.cptY ? pre : next
            })
        },
        // 获取右边最大值组件
        getRightMax(list) {
            if (!list.length) return 0
            return list.reduce((pre, next) => {
                let preRight = pre.cptX + pre.cptWidth
                let nextRight = next.cptX + next.cptWidth
                return preRight > nextRight ? pre : next
            })
        },
        // 获取左边最大值组件
        getLeftMax(list) {
            if (!list.length) return 0
            return list.reduce((pre, next) => pre.cptX < next.cptX ? pre : next)
        },
        // 获取底部最大值组件
        getBottomMax(list) {
            if (!list.length) return 0
            return list.reduce((pre, next) => {
                let preBottom = pre.cptY + pre.divHeight
                let nextBottom = next.cptY + next.divHeight
                return preBottom > nextBottom ? pre : next
            })
        }
    }

    /**
     * @title 组合
     * 组合控件少用, 后续替换新方案
     */
    class onGroup {
        /**
         * 初始化函数，根据传入的type类型执行不同的初始化逻辑。
         * @param {string} type 初始化的类型，可以是'cancel'或者'oneCancel'，以及其他可能的值。
         */
        static init(type) {
            // 根据type类型取消分组或单个取消分组的操作
            if (type === 'cancel') {
                onGroup.cancelGroup() // 取消所有分组
                return
            } else if (type === 'oneCancel') {
                onGroup.oneCancelGroup(props.selectedComponents.value) // 取消当前分组
                return
            }
            console.log('分组开始执行', props.cacheChoices)
            // 从props中获取cacheChoices并转换为数组
            const cacheChoicesArray = Object.values(props.cacheChoices)

            // 检查是否有已经存在的分组
            let hasGroup = cacheChoicesArray.find(x => x?.groupCompName)
            if (!hasGroup) {
                // 如果没有分组，则自动增加分组编号
                props.designData.groupNumber = isNaN(props.designData.groupNumber) ? 1 : props.designData.groupNumber + 1
            }

            // 查找当前分组的最后一个组件，为了设置分组的标记名
            let stepLastItem = props.cacheComponents.find(x => x.groupCompName == `group-${props.designData.groupNumber}`)


            console.log(props.cacheChoices, 'props.cacheChoices');
            let isSuspension = null
            let groupNewList = []
            for (const key in props.cacheChoices) {
                console.log(props.cacheChoices[key], 'props.cacheChoices[key]');
                if (props.cacheChoices[key]?.cptType === 'cpt-suspension') {
                    isSuspension = JSON.parse(JSON.stringify(props.cacheChoices[key]))
                } else {
                    groupNewList.push(key)
                }
            }
            if (isSuspension) {
                for (let i = 0; i < props.cacheComponents.length; i++) {
                    const item = props.cacheComponents[i];
                    // let getSuspensionIndex = String(isSuspension.cptOption.attribute.cptIndex).slice(0, 1)
                    // let getSuspensionIndexTwo = String(isSuspension.cptOption.attribute.cptIndex).slice(1,2)
                    let getIndex = groupNewList.indexOf(item.id)
                    if (getIndex != -1) {
                        props.cacheComponents[i].cptOption.attribute.cptIndex = Number(isSuspension.cptOption.attribute.cptIndex) + (i + 1)
                        // props.cacheComponents[i].cptOption.attribute.cptIndex = Number(getSuspensionIndex + '' + getSuspensionIndexTwo + '0000' + (getIndex + 1))
                        // console.log(props.cacheComponents[i], props.cacheComponents[i].cptOption.attribute.cptIndex, getSuspensionIndex, getIndex, 'props.cacheComponents[i]');
                    }
                    console.log(item, props.cacheChoices[item.id], 'qwdoikqwdikojqwdoiwqdkoqwdkoqwdko');
                }
                console.log(isSuspension, groupNewList, 'qwdokmqwodqwdokqwokdkoqw');
            }



            // 遍历所有组件，为每个组件设置分组信息
            props.cacheComponents.forEach((item, index) => {
                for (const key in props.cacheChoices) {
                    if (item.id == key) {
                        let groupName = 'group-' + props.designData.groupNumber
                        item.group = cacheChoicesArray.map(x => x.id) // 设置组件所属分组的ID集合

                        if (!item?.groupCompName) {
                            // 如果组件还没有分组名称，则设置分组名称，并更新组件信息
                            item.groupCompName = groupName
                            item = { ...item, ...onGroup.setMultilevelGroup(item, stepLastItem) }
                        } else {
                            let multilevelGroup = 'group-' + props.designData.groupNumber
                            // 多级分组组合
                            item = onGroup.mergeGroups(item, multilevelGroup)
                        }
                        console.log(item.cptTitle, item, item.oldGroupsCompsNames, groupName, 'qwdjiqwidjidqiji')
                    }
                }
            })
            // 清除并重新设置分组边框
            onGroup.clearGroupBorder()
            onGroup.setGroupBorder()

            // 注释掉的代码，可能是用于监视选中组件变化的函数调用
            // onGroup.watchSelectComps()
            // 初始化组件点击事件处理
            onGroup.initCompsClick()
        }
        /**
         * @title 多级分组组合
         */
        static mergeGroups(item, multilevelGroup) {
            let oldItem = JSON.parse(JSON.stringify(item))
            if (item.hasOwnProperty('oldGroupsCompsNames')) {
                item.oldGroupsCompsNames.push(oldItem.groupCompName)
            } else {
                item.oldGroupsCompsNames = [oldItem.groupCompName]
            }
            onGroup.clearGroupBorder()

            item.groupCompName = multilevelGroup

            return item
        }
        /**
         * 设置多级分组信息
         * @param {Object} item - 当前需要设置分组信息的对象
         * @param {Object} lastItem - 上一个设置分组信息的对象，用于确定当前分组的层级
         * @returns {Object} 返回经过分组信息设置后的对象
         */
        static setMultilevelGroup(item, lastItem) {
            // 判断lastItem是否存在并具有cptMultilevelGroup属性
            if (lastItem?.cptMultilevelGroup) {
                // 如果存在，则基于上一个分组的cptMultilevelGroup值和当前分组的位置设置当前分组的cptMultilevelGroup
                item.cptMultilevelGroup = lastItem.cptMultilevelGroup + '|' + (item.group.length + 1);
            } else {
                // 如果不存在，则直接基于当前分组的组名和位置设置cptMultilevelGroup
                item.cptMultilevelGroup = item.groupCompName + '|' + (item.group.length + 1);
            }
            return item // 返回设置好分组信息的对象
        }
        // static watchSelectComps() {
        //     // watch(props.selectedComponents.value, value => {
        //     //     onGroup.clearGroupBorder()
        //     //     onGroup.setGroupBorder()
        //     // }, { deep: true })
        //     const selectComps = Object.values(props.cacheChoices)
        //     watch(selectComps, value => {
        //         console.log('watch selectComps')
        //         // for (const key in value) {
        //         //     if (value[key]?.group) {
        //         //         onGroup.clearGroupBorder()
        //         //         onGroup.setGroupBorder()
        //         //     }
        //         // }
        //         onGroup.clearGroupBorder()
        //         onGroup.setGroupBorder()
        //     }, { deep: true })


        //     // onGroup.setGroupBorder()

        // }
        // 清除组边框
        static clearGroupBorder() {
            let groupIdList = props.cacheComponents.filter(({ groupCompName }) => groupCompName).map(({ groupCompName }) => groupCompName)
            let idList = Array.from(new Set(groupIdList))

            idList.forEach(item => {
                const findGroupDiv = Array.from(props.refMap['webContainer'].children).find(x => x.id == item)

                if (findGroupDiv) {
                    findGroupDiv.style.border = ''
                }
            })
        }
        // 清除全部组边框
        static clearAllGroupBorder() {
            let groups = props.cacheComponents.map(x => x.groupCompName).filter(x => x)
            let groupArr = groups.reduce((unique, item) =>
                unique.includes(item) ? unique : [...unique, item], []);

            for (let i = 0; i < groupArr.length; i++) {
                let groupDiv = document.getElementById(groupArr[i])
                groupDiv && groupDiv.remove()
            }
        }
        //设置组边框 
        static setGroupBorder() {
            let filterBorderList = ['combination', 'combination-border', 'combination-group', 'ngcombination', 'ngcombination-border']
            const notBorder = props.selectedComponents.value.some(x => filterBorderList.includes(x?.cptType))

            const groupData = onGroup.groupDataHandler()

            for (const key in groupData) {
                const leftComp = getPoistion.getLeftMax(groupData[key])
                const topComp = getPoistion.getTopMax(groupData[key])
                const rightComp = getPoistion.getRightMax(groupData[key])
                const bottomComp = getPoistion.getBottomMax(groupData[key])
                const borderColor = notBorder ? '' : '2px dashed rgba(37, 137, 255,0.4)'
                // const borderColor = '2px dashed rgba(37, 137, 255,0.4)'

                // 创建
                const findGroupDiv = Array.from(props.refMap['webContainer'].children).find(x => x.id == key)
                // console.log(document.getElementById(key),'aijdiasdiadjiasdjisadjiaijsdjsi');
                // console.log(findGroupDiv,'findGroupDiv');
                // const findGroupDiv = document.getElementById(key)
                // console.log(findGroupDiv)

                if (!findGroupDiv) {
                    // 阻止生成undefine 元素
                    if (key && key != 'undefined' && key != 'null') {
                        let div = document.createElement('div')
                        div.id = key
                        console.log(key, '????')
                        div.class = 'group-div'
                        div.style.position = 'absolute'
                        div.style.left = leftComp.cptX + 'px'
                        div.style.zIndex = -1;
                        div.style.top = topComp.cptY + 'px'
                        div.style.width = (rightComp.cptX + rightComp.cptWidth) - leftComp.cptX + 'px'
                        div.style.height = (bottomComp.cptY + bottomComp.cptHeight) - topComp.cptY + 'px'
                        div.style.border = borderColor
                        props.refMap['webContainer'].appendChild(div)
                    }
                } else {
                    let maxRight;
                    let maxBottom;
                    // 当隐藏组件时 组中单个组件移动会找不到隐藏的最右侧组件 重新查询一次
                    let hasHideComp = groupData[key].find(x => {
                        let isHide = (x.cptShow == false || x.cptShow && x.cptLookShow)
                        let isSize = leftComp.cptX < x.cptX
                        return isHide && isSize
                    })
                    if (hasHideComp) {
                        maxRight = groupData[key].reduce((p, n) => (p.cptX + p.cptWidth) > (n.cptX + n.cptWidth) ? p : n)
                        maxBottom = groupData[key].reduce((p, n) => (p.cptY + p.cptHeight) > (n.cptY + n.cptHeight) ? p : n)
                        findGroupDiv.style.width = (maxRight.cptX + maxRight.cptWidth) - leftComp.cptX + 'px'
                        findGroupDiv.style.height = (maxBottom.cptY + maxBottom.cptHeight) - topComp.cptY + 'px'
                    } else {
                        findGroupDiv.style.width = (rightComp.cptX + rightComp.cptWidth) - leftComp.cptX + 'px'
                        findGroupDiv.style.height = (bottomComp.cptY + bottomComp.cptHeight) - topComp.cptY + 'px'
                    }

                    findGroupDiv.style.left = leftComp.cptX + 'px'
                    findGroupDiv.style.top = topComp.cptY + 'px'
                    findGroupDiv.style.border = borderColor
                }

                onGroup.verifyHideCompStopSelect(groupData[key])
            }
        }
        //给组组件注册点击事件
        static initCompsClick() {
            for (const key in props.cacheChoices) {
                if (!props.cacheChoices[key]?.groupCompName) {
                    return
                }
                if (!props.refMap[`div${[key]}`]) {
                    return
                }
                props.refMap[`div${[key]}`].ondblclick = (e) => {
                    let current = props.cacheComponents.find(({ id }) => id == key)
                    current.isDbclick = true
                    console.log(props.cacheChoices[key], 'props.cacheChoices[key]');
                    setObj(props.cacheChoices, { [key]: props.cacheChoices[key] })
                }
            }
        }
        // 取消组合时，组合里面只有单个组件，故无需处理复合组件
        static cancelGroup(type) {
            let list = props.selectedComponents.value
            // 单个组件 id集合
            const singleCompIds = list.filter(x => !props.combinationTypes.value.includes(x.cptType)).map(x => x.id)
            // 找到 cptMultilevelGroup 属性用 | 

            let maxLength = 0;
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                let length = item.cptMultilevelGroup?.split('|').length;
                if (length > maxLength) {
                    maxLength = length;
                }
            }

            // 找到所有 cptMultilevelGroup 属性用 | 分割后长度等于最大长度的对象
            let maxObjs = list.filter(item => item.cptMultilevelGroup?.split('|').length === maxLength);

            // 如果找到了这样的对象，然后进行你的操作
            if (maxObjs.length > 0) {
                for (let i = 0; i < maxObjs.length; i++) {
                    let maxObj = maxObjs[i];

                    // 遍历 list 数组中的每个对象
                    for (let j = 0; j < list.length; j++) {
                        let item = list[j];
                        if (!type && (item?.cptType === 'combination' || item?.cptType === 'combination-border')) {
                            // 去除组合操作加进来的单个控件的 id
                            item.group = item.group.filter(x => !singleCompIds.includes(x))
                            continue
                        }
                        // 检查 group 数组中是否包含 maxObj 的 id
                        if (item?.group) {
                            let index = item.group.indexOf(maxObj.id);
                            if (index !== -1) {
                                item.group.splice(index, 1);
                            }
                        }

                        // 判断当前组是否为最后一项组 删除组边框
                        let isGroupLen = list[j].cptMultilevelGroup?.split('|')?.length <= 2
                        if (isGroupLen) {
                            let groupDiv = document.getElementById(list[j].groupCompName)
                            groupDiv && groupDiv.remove()
                        }

                        // 如果对象的 id 与 maxObj 的 id 相同，就删除 cptMultilevelGroup，group 和 groupCompName 属性
                        if (item.id === maxObj.id) {
                            delete item.cptMultilevelGroup;
                            delete item.group;
                            delete item.groupCompName;
                        }
                    }
                }
            }

            let new_cacheChoices = {}
            // let new_list = list.filter(x => x.groupCompName)
            // 排除掉组合控件
            let new_list = list.filter(x => x.groupCompName && !props.combinationTypes.value.includes(x.cptType))
            new_list.forEach(item => {
                new_cacheChoices[item.id] = item
            })

            setObj(props.cacheChoices, new_cacheChoices)
            setLotsizePoistion()


        }
        // 一键取消组合
        static oneCancelGroup(components) {
            // 单个组件 id集合
            const singleCompIds = components.filter(x => !props.combinationTypes.value.includes(x.cptType)).map(x => x.id)
            components.forEach(item => {
                if (item?.cptType === 'combination' || item?.cptType === 'combination-border') {
                    // 去除组合操作加进来的单个控件的 id
                    item.group = item.group.filter(x => !singleCompIds.includes(x))
                    return
                }
                let groupDiv = document.getElementById(item.groupCompName)
                groupDiv && groupDiv.remove()
                delete item.group
                delete item.groupCompName
            })
            setObj(props.cacheChoices, {})
        }
        // 处理组数据
        static groupDataHandler() {
            let namesList = props.selectedComponents.value.map(x => x.groupCompName)
            namesList = Array.from(new Set(namesList))

            if (!namesList.length) {
                return
            }

            let obj = {}
            namesList.forEach(name => {
                if (!name) {
                    return
                }
                obj[name] = []
                props.cacheComponents.forEach(item => {
                    let groupName = name == item.groupCompName ? name : null
                    if (groupName) {
                        obj[groupName].push(item)
                    }
                })
            })
            return obj
        }
        // 处理组边框展示
        static groupStyleHandler() {
            // 问题: 会导致没有组合的单组件没有选中样式 
            let selectNumber = props.selectedComponents.value.length

            let isSelectGroup = props.selectedComponents.value.find(x => x.groupCompName)
            let flag = selectNumber > 0 || !isSelectGroup

            return flag
        }
        /**
         * 撤回执行操作
         * @param {string} type on 组合  off 取消组合
         * @param {Array} list 上一次数组 
         */
        static withDraw(type, list) {
            console.log(type, list)

            let obj = {}
            list.forEach(item => {
                obj[item.id] = item
            })
            setObj(props.cacheChoices, obj)

            switch (type) {
                case 'off':
                    onGroup.cancelGroup()
                    break;
                case 'on':
                    onGroup.init()
                    break;
                default:
                    break;
            }

        }
        static onTouchGroupComponent() {
            const groupData = onGroup.groupDataHandler()
            for (const key in groupData) {
                const findDbclickComp = groupData[key].find(x => x.isDbclick)
                // 双击事件阻止全选触发
                if (findDbclickComp) {
                    findDbclickComp.isDbclick = false
                    return 'dbClick'
                }
                groupData[key].forEach(item => {
                    props.cacheChoices[item.id] = item
                    props.cacheChoicesFixed[item.id] = JSON.parse(JSON.stringify(item))
                })
            }
        }
        // 组件组所有组件隐藏不选中
        static verifyHideCompStopSelect(selectList) {
            let hideGroups = selectList.every(x => x.cptShow == false)
            let ids = selectList.map(x => x.cptShow == false ? x.id : false).filter(x => x)
            if (hideGroups) {
                onGroup.clearGroupBorder()
                for (const key in props.cacheChoices) {
                    ids.forEach(id => {
                        delete props.cacheChoices[id]
                    })
                }
            }
        }

    }


    /**
     * @title 组合选项卡
     */
    class CombinationTab {
        static init(options) {

            const findCombinationTab = props.cacheComponents.find(x => x?.cptType === 'combination' && options.includes(x.id))
            const tabBorder = props.cacheComponents.find(x => x?.cptType === 'combination-border' && options.includes(x.id))
            const isGroup = findCombinationTab?.groupCompName
            if (findCombinationTab && tabBorder && !isGroup) {
                setObj(props.cacheChoices, {})
                setObj(props.cacheChoices, {
                    [tabBorder.id]: tabBorder,
                    [findCombinationTab.id]: findCombinationTab,
                })

                onGroup.init()
                CombinationTab.setDefaultCombinationTabBorder()

            }
        }


        // 设置组合选项卡默认边框
        static setDefaultCombinationTabBorder() {
            props.selectedComponents.value.forEach(item => {
                if (item) {
                    item.cptOption.attribute.borderType = 'dv-border-box-0'
                }
            })
        }

        /**
         * @title 组件插入选项卡
         * @param {*} cpt 
         * @param {*} ev 
         * @returns 
         */
        static shiftCombinationComponent(cpt, ev) {
            let tabComps = props.cacheComponents.filter(comp => comp?.cptType == 'combination-border')
            // let tabTitle = props.cacheComponents.find(comp => comp?.cptType == 'combination')
            let cptIndex = props.cacheComponents.findIndex(comp => comp.id == cpt.id)
            if (!tabComps.length) return
            // 
            tabComps.forEach((item) => {
                let findTabTFunc = tabT => tabT.groupCompName === item.groupCompName && tabT?.cptType === 'combination'
                let tabTitle = props.cacheComponents.find(findTabTFunc)
                if (!tabTitle) {
                    return
                }
                // 当选项卡为隐藏不执行操作
                if (tabTitle.cptOption.attribute?.hideCompInTab === true) {
                    return
                }
                // 判断父级id
                const isFatherGridId = item.cptOption.attribute?.fatherGridId
                if (isFatherGridId) {
                    delete item.cptOption.attribute?.fatherTabId
                    return
                }



                if (item.cptOption.attribute.cptDragBorder) {

                    // 当type类型为单个组件时
                    if (ev.type === 'drop') {
                        // 获取触发drop事件的元素（即被拖拽的元素）
                        const draggedElement = ev.target;
                        // 获取被拖拽元素相对于视口的位置
                        const draggedRect = draggedElement.getBoundingClientRect();

                        // 计算左组件 220
                        let containerRectX = (Math.round(draggedRect.left) - 220)
                        // 计算上组件 65
                        let containerRectY = (Math.round(draggedRect.top) - 65)
                        // 目标组件停止覆盖组件 / 缩放
                        let parentOffsetX = Math.round(containerRectX / props.containerScale.value)
                        let parentOffsetY = Math.round(containerRectY / props.containerScale.value)

                        // 目标组件定制覆盖组件 + 当前组件在&的左侧位置
                        cpt.cptX = parentOffsetX + ev.offsetX
                        cpt.cptY = parentOffsetY + ev.offsetY
                    }
                    let currentTab = this.getCurrentTab(tabTitle)
                    const { fatherTabId } = cpt.cptOption.attribute
                    // 当前有选项卡key和组件没有fatherTabId时添加选项卡子组件
                    if (currentTab && !fatherTabId) {
                        // 给组件添加选项卡id
                        cpt.cptOption.attribute.fatherTabId = tabTitle?.id
                        cpt.cptOption.attribute.cptFatherId = tabTitle?.id

                        const newCpt = this.setTabContentIndex({ cpt, tabTitle, currentTab })

                        cpt.cptOption.attribute.cptIndex = newCpt?.cptIndex

                        // 禁止拖入选项卡的组件
                        console.log(cpt, 'itemitemitemitemitemitemitemitemitemitem');
                        const isStopComp = cpt.cptOption.attribute?.combinationCompId
                        if (isStopComp) {
                            return
                        }

                        if (tabTitle.tabGroup[currentTab]) {
                            tabTitle.tabGroup[currentTab].push(cpt.id)
                        } else {
                            tabTitle.tabGroup[currentTab] = [cpt.id]
                        }
                    }


                    let nowCpt = props.cacheComponents.splice(cptIndex, 1)[0]
                    props.cacheComponents.unshift(nowCpt)

                }
            })

        }
        /**
         * @title 查找当前父级组件
         * @param {*} tabList 
         * @param {*} selectItem 
         * @returns 
         */
        static getCompInTabContent(tabList, selectItem) {
            // 当前组件存在多少选项卡内容区中
            const CompInTabList = tabList.map(tabBorderItem => {
                // 查找当前选项卡内容区域的选项卡
                let tabTitleId = tabBorderItem?.group && tabBorderItem?.group.filter(x => x !== tabBorderItem.id)
                let tabTitleItem = props.cacheComponents.find(x => {
                    return x?.cptType === 'combination' && tabTitleId?.includes(x.id)
                })
                let bgTitleItem = props.cacheComponents.find(x => {
                    return x?.cptType === 'ngcombination' && tabTitleId?.includes(x.id)
                })
                let xfTitleItem = props.cacheComponents.find(x => {
                    return x?.cptType === 'cpt-suspension'
                })

                // 计算选项卡内容区
                let leftX = tabBorderItem?.cptX
                let rightX = tabBorderItem?.cptX + tabBorderItem?.cptWidth
                let topY = tabBorderItem?.cptY
                let bottomY = tabBorderItem?.cptY + tabBorderItem?.cptHeight

                // 当组件大于选项卡不执行操作
                let itemWh = selectItem?.cptWidth + selectItem?.cptHeight
                let tabBorderWh = tabBorderItem.cptWidth + tabBorderItem.cptHeight
                if (itemWh > tabBorderWh) {
                    return
                }

                // 比较选中组件是否进入选项卡内容区
                let itemCompX = selectItem?.cptX + selectItem.cptWidth
                let itemCompY = selectItem?.cptY + selectItem.cptHeight
                let isEnter = (itemCompX > leftX && itemCompX < rightX) && (itemCompY > topY && itemCompY < bottomY)

                if (isEnter) {
                    if (tabTitleItem) return tabTitleItem
                    if (bgTitleItem) return bgTitleItem
                    if (xfTitleItem) return xfTitleItem
                } else {
                    return null
                }

                // return isEnter ? (tabTitleItem ? tabTitleItem : bgTitleItem) : null
            }).filter(x => x && !x.cptOption.attribute.hideCompInTab)

            console.log(CompInTabList, 'CompInTabList');

            if (CompInTabList.length === 0) {
                return false
            }

            // 查询嵌套内级别最大的选项卡
            const currentInTab = CompInTabList.reduce((accumulator, current) => {
                let currentLevel = current.cptOption.attribute?.cptTabLevel
                let accumulatorLevel = accumulator.cptOption.attribute?.cptTabLevel || 1
                return currentLevel > accumulatorLevel ? current : accumulator
            }, CompInTabList[0])

            console.log(currentInTab, 'currentInTabcurrentInTabcurrentInTabcurrentInTab');
            return currentInTab
        }
        /**
       * @title 初始化选项卡设置图层层级
       */
        static setTabContentIndex() {

            console.log(arguments, '初始化选项卡设置图层层级');

            const { cpt, tabTitle, currentTab } = arguments[0]
            // 设置父级id
            cpt.cptOption.attribute.cptFatherId = tabTitle?.id

            let itemCptIndex = tabTitle.tabGroup[currentTab].length + 2
            let fatherTabIndex = String(tabTitle.cptOption.attribute.cptIndex).slice(0, 1)
            console.log(fatherTabIndex, 'fatherTabIndexfatherTabIndex');
            if (!isNaN(Number(fatherTabIndex))) {
                if (cpt?.cptType === 'combination') {
                    // 选项卡 
                    cpt.cptOption.attribute.cptIndex = Number((Number(fatherTabIndex) + 1) + '100000')
                } else if (cpt?.cptType === 'ngcombination') {
                    // 九宫格
                    cpt.cptOption.attribute.cptIndex = Number((Number(fatherTabIndex) + 1) + '000000')
                } else if (cpt?.cptType === 'combination-border') {
                    cpt.cptOption.attribute.cptIndex = Number(fatherTabIndex + '000001')
                } else {
                    // console.log(Number(fatherTabIndex), Number(itemCptIndex), tabTitle.tabGroup[currentTab].length, 'qwdijqwjd8udqwud');
                    // 单控件
                    cpt.cptOption.attribute.cptIndex = Number(fatherTabIndex + '00000' + itemCptIndex)
                }
            }


            const { cptIndex, cptFatherId } = cpt.cptOption.attribute
            return {
                cptIndex, cptFatherId
            }
        }
        /**
        * @title 设置选项卡及子组件所有层级
        */
        static setTabContentCompIndex(tab, type) {

            if (tab?.cptType === 'ngcombination') {
                tab.tabGroup[`index-0`].forEach((id, index) => {
                    forSetChildItem(id, index, tab, 'index-0')
                })
            } else {
                const tabKeys = this.getCurrentTab(tab)
                let tabBorder = props.cacheComponents.find(x => tab?.group?.includes && x?.cptType === 'combination-border')
                let fristNumber = String(tab.cptOption.attribute.cptIndex)
                tabBorder.cptOption.attribute.cptIndex = Number(fristNumber.slice(0, 1) + '000001')
                tab.tabGroup[tabKeys].forEach((id, index) => {
                    forSetChildItem(id, index, tab, tabKeys)
                })
            }


            function forSetChildItem(id, index, tabParams, tabKeys) {
                const list = props.cacheComponents

                let comp = list.find(c => c.id == id)
                const { cptTabLevel, cptIndex } = tabParams.cptOption.attribute
                let fatherCptIndex = Number(String(cptIndex).slice(0, 1) + '000000')
                console.log(fatherCptIndex, 'fatherCptIndex');
                if (comp?.cptType === 'combination') {
                    comp.cptOption.attribute.cptTabLevel = cptTabLevel + 1
                    comp.cptOption.attribute.cptIndex = fatherCptIndex + 1100000
                    let compBorder = props.cacheComponents.find(x => comp.group.includes(x.id) && x.cptType === 'combination-border')
                    compBorder.cptOption.attribute.cptIndex = fatherCptIndex + 1000001

                    // 关联组件
                    // let tabGroupList = props.cacheComponents.filter(x => comp.group.includes(x.id) && x.cptType !== 'combination-border' && x.cptType !== 'combination')
                    // for (let i = 0; i < tabGroupList.length; i++) {
                    //     const tabGroupItem = tabGroupList[i];
                    //     tabGroupItem.cptOption.attribute.cptIndex = cptIndex + 1000000 + (i + 1)
                    // }
                    CombinationTab.setTabInGroupComp(props.cacheComponents, comp)



                    for (const key in comp.tabGroup) {
                        comp.tabGroup[key].forEach((cId, cIndex) => {
                            forSetChildItem(cId, cIndex, comp)
                        })
                    }
                } else if (comp?.cptType === 'ngcombination') {
                    // console.log(tabParams.tabGroup[tabKeys], 'asadads', cptIndex + 100000);
                    // CombinationNg.childIndex(tabParams.tabGroup[tabKeys],)
                    comp.cptOption.attribute.cptTabLevel = cptTabLevel + 1
                    comp.cptOption.attribute.cptIndex = fatherCptIndex + 1000000
                    CombinationNg.sortIndex(comp, comp.tabGroup['index-0'])
                } else {
                    // if (comp?.cptType === 'combination-border') {
                    //     comp.cptOption.attribute.cptIndex = cptIndex + 100001
                    // } else {
                    //     comp.cptOption.attribute.cptIndex = cptIndex + (index + 2)
                    // }
                    if (comp && comp?.cptType !== 'combination-border') {
                        comp.cptOption.attribute.cptIndex = fatherCptIndex + (index + 2)
                    }


                }
            }
            // console.log(cptItem, 'tabtabtabtabtab');

            // if (cptItem?.tabGroup) {
            //     for (const key in cptItem.tabGroup) {
            //         // cptItem.tabGroup[key]?.forEach((findid, index) => {
            //         //     let cpt = props.cacheComponents.find(x => findid == x.id)
            //         //     console.log(cptItem.cptOption.attribute.cptIndex,cpt.cptTitle,'cptItem.cptOption.attribute.cptIndex');
            //         //     cpt.cptOption.attribute.cptIndex = cptItem.cptOption.attribute.cptIndex + index + 2
            //         //     if (cpt?.cptType === 'combination') {
            //         //         this.setTabContentCompIndex(cpt)
            //         //     }
            //         // })
            //     }
            // }
        }
        /**
         * @title 设置选项卡关联组件层级
         */
        static setTabInGroupComp(components, tab) {

            // if (tab?.cptType === 'combination') {
            //     let tabBorder = components.find(x => tab?.group?.includes && x?.cptType === 'combination-border')
            //     let fristNumber = String(tab.cptOption.attribute.cptIndex)
            //     tabBorder.cptOption.attribute.cptIndex = Number(fristNumber.slice(0, 1) + '000001')
            // }
            if (tab?.cptType !== 'combination') {
                return
            }
            let tabGroupList = components.filter(x => tab?.group?.includes(x.id) && x?.cptType !== 'combination-border' && x?.cptType !== 'combination')

            for (let i = 0; i < tabGroupList.length; i++) {
                const tabGroupItem = tabGroupList[i];
                tabGroupItem.cptOption.attribute.cptIndex = tab.cptOption.attribute.cptIndex + (i + 1)
            }
        }
        /**
         * @title 拖拽选项卡添加删除组件 - 移除组件
         * @param {*} tabTitle 
         * @param {*} item 
         */
        static removeTabInContent(tabTitle, item) {
            for (const key in tabTitle.tabGroup) {
                tabTitle.tabGroup[key]?.forEach((removeItem, removeIndex) => {
                    if (item.id == removeItem) {
                        // 移除
                        tabTitle.tabGroup[key]?.splice(removeIndex, 1)
                        const { fatherTabId, cptFatherId } = item.cptOption.attribute
                        // 判断不是九宫格组件
                        const isNgComp = item?.cptType != 'ngcombination' && item?.cptType != 'ngcombination-border'
                        // 删除父级id
                        if (fatherTabId) {
                            delete item.cptOption.attribute.fatherTabId
                        }
                        if (cptFatherId && isNgComp) {
                            delete item.cptOption.attribute.cptFatherId
                        }
                        item.cptOption.attribute.cptTabLevel = 1
                        item.cptOption.attribute.cptIndex = 1000000


                        // 关联组件
                        this.setTabInGroupComp(props.cacheComponents, item)

                        if (item?.cptType === 'combination') {
                            item.cptOption.attribute.cptIndex = 1100000
                            this.setTabContentCompIndex(item)
                        } else if (item?.cptType === 'ngcombination') {
                            console.log(item.cptOption.attribute.cptIndex, 'item.cptOption.attribute.cptIndex');
                            CombinationNg.sortIndex(item, item.tabGroup['index-0'])
                        } else if (item?.cptType === 'combination-border') {
                            item.cptOption.attribute.cptIndex = 1000001
                        }
                    }
                })
            }
        }

        /**
         * @title 拖拽选项卡添加删除组件 - 添加组件
         * @param {*} tab 父级选项卡
         * @param {*} selectItem 当前拖动组件
         * @returns 
         */
        static addCompInTabContent(tab, selectItem) {
            console.log(tab.id === selectItem.id, 'ceshi', 333);
            if (tab.id === selectItem.id) {
                let fristNumber = String(selectItem.cptOption.attribute.cptIndex)
                selectItem.cptOption.attribute.cptIndex = Number(fristNumber.slice(0, 1) + '100000')
                return
            }


            let currentTab = this.getCurrentTab(tab)


            // 禁止拖入选项卡的组件
            const isStopComp = selectItem.cptOption.attribute?.combinationCompId
            if (isStopComp) {
                return
            }

            // const { hideCompInTab, cptTabLevel } = tab.cptOption.attribute
            // console.log(hideCompInTab,'ceshi');
            // // 当选项卡为隐藏不执行操作
            // if (hideCompInTab === true) {
            //     return
            // }
            const { cptTabLevel } = tab.cptOption.attribute
            console.log('', 1);
            const hasComp = CombinationTab.hasCompInTab(tab, selectItem)
            if (hasComp) {
                return
            }
            console.log('ceshi', 2);

            // 判断九宫格父级id
            const isFatherGridId = selectItem.cptOption.attribute?.fatherGridId
            if (isFatherGridId) {
                delete selectItem.cptOption.attribute?.fatherTabId
                return
            }
            console.log('ceshi', 3);

            const { fatherTabId } = selectItem.cptOption.attribute
            if (fatherTabId && fatherTabId != tab.id) {
                let fatherTab = props.cacheComponents.find(({ id }) => id === fatherTabId)
                this.removeTabInContent(fatherTab, selectItem)
            }

            // 关联组合选项卡组件不执行
            const isTabGroupComp = selectItem.cptOption.attribute.isTabGroupId
            if (isTabGroupComp) {
                return
            }
            console.log('ceshi', 4);



            selectItem.cptOption.attribute.fatherTabId = tab.id
            selectItem.cptOption.attribute.cptFatherId = tab.id

            // 设置选项卡级别
            if (selectItem?.cptType === 'combination' || selectItem?.cptType === 'cpt-suspension') {
                selectItem.cptOption.attribute.cptTabLevel = cptTabLevel + 1
                const newCptIndex = selectItem.cptOption.attribute.cptTabLevel
                selectItem.cptOption.attribute.cptIndex = Number(newCptIndex + '100000')

            } else {
                // 设置单组件层级
                const newCpt = this.setTabContentIndex({ cpt: selectItem, tabTitle: tab, currentTab })
                // 设置层级
                selectItem.cptOption.attribute.cptIndex = newCpt?.cptIndex
            }

            // 兼容tabGroup是否是数组
            let isTabGroup = tab.tabGroup && Array.isArray(tab.tabGroup[currentTab])
            if (isTabGroup) {
                tab.tabGroup[currentTab].push(selectItem.id)
            } else {
                tab.tabGroup[currentTab] = [selectItem.id]
            }
            if (selectItem?.cptType == 'combination') {
                this.setTabContentCompIndex(tab)
            } else if (selectItem?.cptType == 'ngcombination') {
                let tabIndex = Number(String(tab.cptOption.attribute.cptIndex).slice(0, 1) + '000000')
                CombinationNg.childIndex(tab.tabGroup[currentTab], tabIndex + 1000000)
            }
        }
        /**
         * @title 拖拽添加删除组件
         */
        static actionAddTabInComponent() {

            // 查找选项卡过滤选中的选项卡
            const filterTabList = props.cacheComponents.filter(item => {
                let selectedList = props.selectedComponents.value
                // 过滤选中选项卡
                let hasSelectedTab = selectedList.findIndex(x => {
                    return item.id == x.id && x?.cptType === 'combination-border'
                })
                let hasSelectedNg = selectedList.findIndex(x => {
                    return item.id == x.id && x?.cptType === 'ngcombination-border'
                })
                let hasSelectedXf = selectedList.findIndex(x => {
                    return item.id == x.id && x?.cptType === 'cpt-suspension'
                })
                return (item?.cptType === 'combination-border' && hasSelectedTab == -1) ||
                    (item?.cptType === 'ngcombination-border' && hasSelectedNg == -1) ||
                    (item?.cptType === 'cpt-suspension' && hasSelectedXf == -1)
            })
            let selectedList = props.selectedComponents.value

            // 过滤选中选项卡
            let selectHasTab = props.selectedComponents.value.filter(item => {

                return (item?.cptType === 'combination' || item?.cptType === 'combination-border') ||
                    (item?.cptType === 'ngcombination' || item?.cptType === 'ngcombination-border') ||
                    (item?.cptType === 'cpt-suspension')
            })

            if (selectHasTab.length > 0) {
                // 当选中列表有组合选项卡时 修改选中列表 取消选项卡子组件执行
                selectedList = selectHasTab
            }
            for (let i = 0; i < selectedList.length; i++) {
                const selectItem = selectedList[i];

                // 如果父级组件在选中时 不执行
                let fatherInSelected = selectedList.some(x => x.id === selectItem.cptOption.attribute.fatherTabId)
                if (fatherInSelected) {
                    continue
                }

                let fatherBox = this.getCompInTabContent(filterTabList, selectItem)

                console.log(fatherBox, '拖动父级组件');

                if (fatherBox) {
                    switch (fatherBox?.cptType) {
                        case 'combination':
                            console.log('选项卡');
                            this.addCompInTabContent(fatherBox, selectItem)
                            break;
                        case 'cpt-suspension':
                            console.log('悬浮框');
                            console.log(fatherBox.cptOption.attribute.cptIndex, selectedList, i, selectedList.length, 'selectedList');
                            // Suspension.moveGroupComponent({
                            //     fatherBox,
                            //     selectedList,
                            //     index: i,
                            //     onGroup,
                            //     cacheChoices: props.cacheChoices,
                            //     cacheComponents: props.cacheComponents,
                            //     callback: () => {

                            //     }
                            // })
                            break;
                        default:
                            break;
                    }
                    // if (fatherBox?.cptType === 'combination') {
                    //     this.addCompInTabContent(fatherBox, selectItem)
                    // } else if (fatherBox?.cptType === 'cpt-suspension') {
                    //     // 悬浮框
                    //     console.log('哎');
                    // }
                    // 执行完成后 将层级递增

                } else {
                    let isFatherId = selectItem.cptOption.attribute?.fatherTabId
                    if (!isFatherId) {
                        continue
                    }
                    // 删除子组件
                    let fatherTab = props.cacheComponents.find(({ id }) => id === isFatherId)
                    if (fatherTab) {
                        this.removeTabInContent(fatherTab, selectItem)
                    }
                }

            }

        }


        // 当前组件是否存在
        static hasCompInTab(tabTitle, current) {
            let flag = false
            for (const key in tabTitle.tabGroup) {
                tabTitle.tabGroup[key]?.forEach((item, index) => {
                    if (item == current.id) {
                        flag = true
                    }
                })
            }
            return flag
        }
        // 设置拖拽选项卡内边框
        static setCptCompTabBorder({ dragEvent, dragComp, dragStartData }) {

            let tabComps = props.cacheComponents.filter(comp => comp.cptType == "combination-border")

            tabComps.forEach(item => {
                const webContainer = props.refMap['webContainer']
                const componentBar = props.refMap['component-bar']
                const headBar = props.refMap['headBar']
                let boxLeft = webContainer.offsetLeft + componentBar.clientWidth

                let drags = dragEvent.target.clientWidth - dragStartData.x

                let dragX = dragEvent.x - (webContainer.offsetLeft + componentBar.clientWidth)
                let dragY = dragEvent.y - (20 + headBar.$el.clientHeight)

                let dragLx = dragX + (dragEvent.target.clientWidth - dragStartData.x)
                let dragRx = dragX - dragStartData.x

                let dragTx = dragY + (dragEvent.target.clientHeight - dragStartData.y)
                let dragBx = dragY + (dragEvent.target.clientHeight - dragStartData.y) + dragEvent.target.clientHeight

                if (item) {
                    let xEnter = dragLx / props.containerScale.value >= item.cptX
                    let xOut = dragRx / props.containerScale.value < item.cptX + item.cptWidth
                    let yEnter = dragTx / props.containerScale.value >= item.cptY
                    let yOut = dragTx / props.containerScale.value < item.cptY + item.cptHeight

                    item.cptOption.attribute.cptDragBorder = xEnter && xOut && yEnter && yOut
                }
            })


        }
        // 编辑时显示隐藏
        static setTabContentShowHide({ cacheComponents, refMap, currentTab }) {
            let isDesignPage = location.href.includes('/design')
            if (!isDesignPage) {
                return
            }
            let currentKey = this.getCurrentTab(currentTab)

            for (const key in currentTab.tabGroup) {
                let comps = currentTab.tabGroup[key]
                let isShow = currentKey === key

                comps.forEach(compId => {
                    let refComp = refMap[`div${compId}`]
                    if (!refComp) {
                        return
                    }
                    // 组件索引值
                    let compItemIndex = cacheComponents.findIndex(item => item.id === compId)
                    // 当前选项卡是否显示
                    let currentComp = currentTab.cptOption.attribute.hideCompInTab
                    // key相同并且当前选项卡显示(组件显示)
                    if (isShow && !currentComp) {
                        // 显示
                        if (cacheComponents[compItemIndex]) {
                            cacheComponents[compItemIndex].cptOption.attribute.hideCompInTab = false
                        }
                        refComp.classList.remove('tab-hide')

                        if (cacheComponents[compItemIndex]?.cptType === 'ngcombination') {
                            // this.setTabContentShowHideInNinegrid(cacheComponents, compItemIndex, refMap, true)
                            for (const key in cacheComponents[compItemIndex].tabGroup) {
                                cacheComponents[compItemIndex].tabGroup[key].forEach(item => {
                                    let gridChild = cacheComponents.find(c => c.id === item)
                                    if (gridChild) {
                                        gridChild.cptOption.attribute['hideCompInTab'] = gridChild?.cptOption.attribute['hideCompInTab']
                                        if (refMap[`div${gridChild.id}`]) {
                                            refMap[`div${gridChild.id}`].classList.remove('tab-hide')
                                        }
                                    }
                                })
                            }
                        }
                    } else {
                        // 隐藏
                        if (cacheComponents[compItemIndex]) {
                            cacheComponents[compItemIndex].cptOption.attribute.hideCompInTab = true
                        }
                        refComp.classList.add('tab-hide')

                        if (cacheComponents[compItemIndex]?.cptType === 'ngcombination') {
                            for (const key in cacheComponents[compItemIndex].tabGroup) {
                                cacheComponents[compItemIndex].tabGroup[key].forEach(item => {
                                    let gridChild = cacheComponents.find(c => c.id === item)
                                    if (gridChild) {
                                        gridChild.cptOption.attribute['hideCompInTab'] = gridChild?.cptOption.attribute['hideCompInTab']
                                        if (refMap[`div${gridChild.id}`]) {
                                            refMap[`div${gridChild.id}`].classList.add('tab-hide')
                                        }
                                    }
                                })
                            }
                        }
                    }


                })
                // 查询当前选项卡下的选项卡
                let tabComps = currentTab.tabGroup[key].map(id => {
                    let tab = cacheComponents.find(c => c.id === id && c.cptType === 'combination')
                    return tab ? tab : false
                }).filter(x => x)
                // 当有嵌套选项卡时
                if (tabComps.length > 0) {
                    tabComps.forEach(tab => {
                        // 递归
                        this.setTabContentShowHide({ cacheComponents, refMap, currentTab: tab })
                    })
                }
            }

        }
        // 预览时选项卡隐藏显示
        static setPreviewTabContentShowHide({ current, refMap, components }) {
            console.log('预览执行显示隐藏1')
            let isDesignPage = location.href.includes('/design')
            if (isDesignPage) {
                return
            }
            console.log('预览执行显示隐藏2')

            let currentKey = this.getCurrentTab(current)

            console.log(current, 'currentcurrent');

            for (const key in current.tabGroup) {
                let comps = current.tabGroup[key]
                let isShow = currentKey === key

                for (let i = 0; i < comps.length; i++) {
                    const compId = comps[i];
                    // 组件索引值
                    let compItemIndex = components.findIndex(item => item.id === compId)
                    // console.log(compItemIndex, compId,components,current.tabGroup, 'compItemIndexcompItemIndex');
                    if (compItemIndex == -1) {
                        continue
                    }
                    // 当前选项卡是否显示
                    let { hideCompInTab } = current.cptOption.attribute
                    let { cptIndex } = components[compItemIndex].cptOption.attribute

                    if (isShow && !hideCompInTab) {
                        // 显示
                        components[compItemIndex].cptOption.attribute.hideCompInTab = false;
                        // 控制初次加载缓存
                        components[compItemIndex].cptOption.attribute.tabIsCache = true
                        components[compItemIndex].cptOption.attribute.cptIndex = Math.abs(cptIndex);

                        // 判断父级是否是弹窗
                        let isPopup = components.find(cItem => cItem.id === current.cptOption.attribute.cptFatherId && cItem.cptType === 'ngcombination')
                        // 如果父级在弹窗内 增加选项卡子级的层级（弹窗层级：50000）并且+1弹窗层级增加后当前增加数不够
                        if (isPopup) {
                            console.log(current.cptOption.attribute.cptIndex, 'qwdqio0wjdq0i9wdj0iqwwqj0d90qiwd');
                            let currentIndex = current.cptOption.attribute.cptIndex + ''
                            let childIndex = components[compItemIndex].cptOption.attribute.cptIndex + ''

                            let currentIndex01 = currentIndex.slice(0, 2)
                            let childIndex01 = childIndex.slice(0, 2)
                            if (currentIndex01 != childIndex01) {
                                components[compItemIndex].cptOption.attribute.cptIndex = (Number(currentIndex01) + 1) + childIndex.slice(2, childIndex.length)
                            }
                        }
                        // refMap[components[compItemIndex].id] ? refMap[components[compItemIndex].id].refreshCptData(refMap[components[compItemIndex].id]?.current?.cptOption?.cptDataForm) : null;
                    } else {
                        // 不在当前选项卡中的图表也要预加载
                        // (!isShow && components[compItemIndex].cptKey.includes('chart')) ? components[compItemIndex].cptOption.attribute.hideCompInTab = false : components[compItemIndex].cptOption.attribute.hideCompInTab = true;

                        components[compItemIndex].cptOption.attribute.hideCompInTab = true

                        components[compItemIndex].cptOption.attribute.cptIndex = -Math.abs(cptIndex);
                    }
                    // 判断九宫格
                    if (components[compItemIndex] && components[compItemIndex]?.cptType === 'ngcombination') {
                        // const ninegridrefMap = refMap[components[compItemIndex].id]
                        // if (ninegridrefMap) {
                        //     let ninegridDatas = ninegridrefMap.paginatedItems(ninegridrefMap.cptData);
                        //     if(!ninegridrefMap || !ninegridDatas?.length) {
                        //         return 
                        //     }
                        // } 
                        const { hideCompInTab } = components[compItemIndex].cptOption.attribute;

                        for (const key in components[compItemIndex].tabGroup) {

                            components[compItemIndex].tabGroup[key].forEach(item => {
                                // 九宫格子组件处理逻辑
                                let gridChild = components.find(c => c.id === item)
                                if (gridChild) {
                                    let ninegridChild = document.getElementById("div" + gridChild.id)?.getAttribute('ninegridshow')
                                    if (ninegridChild == 'false') {
                                        return
                                    }
                                    const { cptIndex } = gridChild.cptOption.attribute;
                                    if (!hideCompInTab) {
                                        // 控制初次加载缓存
                                        gridChild.cptOption.attribute['tabIsCache'] = true;
                                    }

                                    gridChild.cptOption.attribute['hideCompInTab'] = hideCompInTab;
                                    gridChild.cptOption.attribute['cptIndex'] = hideCompInTab ? -Math.abs(cptIndex) : Math.abs(cptIndex);


                                }
                            })
                        }

                    }
                    // 判断当前选项卡是否在弹窗中


                }

                let tabComps = current.tabGroup[key].map(id => {
                    let tab = components.find(c => c.id === id && c.cptType === 'combination')
                    return tab ? tab : false
                }).filter(x => x)
                // 当有嵌套选项卡时
                if (tabComps.length > 0) {
                    for (let i = 0; i < tabComps.length; i++) {
                        const tab = tabComps[i];
                        this.setPreviewTabContentShowHide({ components, refMap, current: tab })

                    }
                    // tabComps.forEach(tab => {
                    //     // 递归
                    //     this.setPreviewTabContentShowHide({ components, refMap, current: tab })
                    // })
                }
            }

            // for (const key in current.tabGroup) {
            //     current.tabGroup[key].forEach(tabGroupItem => {
            //         let findItem = components.find(item => item.id === tabGroupItem)

            //         if (findItem) {

            //             const isShow = (key === this.getCurrentTab(current)) && current.cptShow
            //             // 处理选项卡子组件
            //             this.setPreviewTabsSetTabComp({ components, tabGroupId: tabGroupItem, isShow })

            //             // 嵌套选项卡处理
            //             this.getAllIdsOfTabs(
            //                 { tComponents: components, tabGroupId: tabGroupItem }
            //                 , allIds => {

            //                     if (isShow) {
            //                         let childTabComp = components.find(x => x.id === tabGroupItem)
            //                         this.setPreviewTabContentShowHide({ components, current: childTabComp })
            //                     } else {
            //                         allIds.forEach(id => {
            //                             // 处理选项卡嵌套选项卡子组件
            //                             this.setPreviewTabsSetTabComp({ components, tabGroupId: id, isShow })
            //                         })
            //                     }

            //                 }
            //             )

            //             // 九宫格处理
            //             let isGrid = findItem.cptType === 'ngcombination'
            //             if (isGrid) {
            //                 for (const key in findItem.tabGroup) {
            //                     findItem.tabGroup[key].forEach(item => {
            //                         let gridChild = components.find(c => c.id === item)
            //                         if (gridChild) {
            //                             gridChild.cptOption.attribute['hideCompInTab'] = findItem?.cptOption.attribute['hideCompInTab']
            //                             console.log('findItem', findItem, gridChild.cptOption.attribute['hideCompInTab'], findItem.cptOption.attribute['hideCompInTab']);

            //                         }
            //                     })
            //                 }
            //             }
            //         }
            //     });
            // }


        }

        /**
         * 循环查询选项卡tabGroup中的id
         * @param {Object} { 选项卡的组件, 选项卡组件的id } 
         * @param {Func} callback 
         */
        static getAllIdsOfTabs({ tComponents, tabGroupId }, callback) {
            // 查询嵌套选项卡
            let tabsInTabComp = tComponents.find(tabC => {
                // 是否是选项卡
                let isTab = tabC?.cptType === 'combination'
                // 是否是嵌套选项卡
                let { fatherTabId } = tabC.cptOption.attribute
                return tabC.id === tabGroupId && isTab && fatherTabId
            })
            if (tabsInTabComp) {
                const allIds = Object.values(tabsInTabComp.tabGroup).reduce((acc, id) => acc.concat(id), []);
                callback && callback(allIds)
            }
        }

        // 选中组合选项卡(拖拽)
        static onTouchCombintionTab(type) {
            const tabTitle = props.selectedComponents.value.find(x => x?.cptType === 'combination')
            const tabBorder = props.selectedComponents.value.find(x => x?.cptType === 'combination-border')


            if (!tabTitle || !tabBorder) {
                return
            }



            const forSetTabChildCompsInCacheChoices = (tabP, tabBorP) => {

                let tabGroupList = props.cacheComponents.filter(c => c?.cptType !== 'combination' && (tabP?.group && tabP?.group.includes(c.id)))

                for (const iterator of tabGroupList) {
                    props.cacheChoices[iterator.id] = iterator
                    props.cacheChoicesFixed[iterator.id] = JSON.parse(JSON.stringify(iterator))
                }

                for (const key in tabP.tabGroup) {
                    tabP.tabGroup[key]?.forEach(item => {
                        let findComp = props.cacheComponents.find(x => x.id === item)

                        // const findCompIndex = props.cacheComponents.findIndex(x => x.id === item)
                        if (!tabBorP || !findComp) {
                            return
                        }
                        if (type === 'cancel') {

                            props.currentCptIndex.value = null
                            // console.log(item != tabP, item,tabP,tabBorP, 'kdkdkdkdkdkdkkd');
                            // // 组合选项卡拖拽结束 清除子组件
                            // if (item != tabP && item != tabBorP) {
                            //     delete props.cacheChoices[item]
                            // }
                            delete props.cacheChoices[item]

                        } else {
                            // 当前是否存在选项卡控件
                            const isTabComp = findComp?.cptType === 'combination' || findComp?.cptType === 'ngcombination'
                            if (isTabComp) {
                                // 查询当前子选项卡的边框
                                let findTabBorFunc = c => findComp.group?.includes(c.id) && (c?.cptType === 'combination-border' || c?.cptType === 'ngcombination-border')
                                // 边框
                                let findCompOnTabBor = props.cacheComponents.find(findTabBorFunc)


                                // 递归
                                forSetTabChildCompsInCacheChoices(findComp, findCompOnTabBor)
                            }

                            props.cacheChoices[item] = findComp
                            props.cacheChoicesFixed[item] = JSON.parse(JSON.stringify(findComp))
                        }


                    })
                }
            }
            forSetTabChildCompsInCacheChoices(tabTitle, tabBorder)
        }
        /**
         * @title 批量删除组合选项卡
         * @param {Object} deleteItem 
         * @returns 
         */
        static delete({ deleteItem, cacheComponents }) {
            if (!deleteItem) {
                return
            }
            // 获取组件父级id
            let fatherTabId = deleteItem.cptOption.attribute?.fatherTabId
            if (!fatherTabId) {
                return
            }
            // 获取组件父级选项卡
            let tab = cacheComponents.find(({ id }) => id == fatherTabId)
            // 获取当前组件所在选项卡的key
            let key = this.findCompontentInTabKey([tab], deleteItem.id)
            if (!key) {
                return
            }
            // 获取组件所在当前选项卡的索引
            let index = tab.tabGroup[key].indexOf(deleteItem.id)
            if (index !== -1) {
                // 删除
                tab.tabGroup[key].splice(index, 1)
                CombinationNg.sortIndex(tab, tab.tabGroup[key])
            } else {
                console.log('选项卡控件删除失败！');
            }

        }
        /**
         * @title 优化选项卡及组件的点击
         * @param {*} param0 
         * @returns 
         */
        static mouseDown(event, selectedComponents) {
            // 是否按下ctrl
            const isOnctrl = event.ctrlKey
            console.log(isOnctrl, 'isOnctrl');
            if (isOnctrl) {
                return
            }
            const isTab = (item, cptType) => (item?.cptType === cptType || item?.cptType === `${cptType}-border`)
            // 选中时是否有组合选项卡
            let filterTabList = selectedComponents.value.filter(item => isTab(item, 'combination') || isTab(item, 'ngcombination'))
            let hasFatherIdNumber = 0
            // 是否存在选项卡和九宫格外部组件
            let isOutTabComp = selectedComponents.value.some(item => {
                let isFather = item.cptOption.attribute?.cptFatherId
                if (!isFather) {
                    hasFatherIdNumber += 1
                }
                return !isFather && !isTab(item, 'combination') && !isTab(item, 'ngcombination')
            })
            // 有外部组件 或者 使用计数器 当外部组件大于2时不执行清除选中
            console.log(isOutTabComp, hasFatherIdNumber, 'ddd');
            if (isOutTabComp || hasFatherIdNumber > 2) {
                return
            }
            console.log(isOutTabComp, 'isOutTabComp');
            // 如果没按下ctrl和没有过滤列表为0 执行清除
            if (filterTabList.length) {
                setObj(props.cacheChoices, {})
            }
        }

        // 选项卡子组件移动层级特殊处理 
        static updateLayer({ type, index, cacheComponents, contextMenu }) {
            /**
             * 判断当前组件是否是选项卡子组件
             *      不是子组件 return false
             *      是子组件
             *        获取当前选项卡索引
             *        下移/置底: 最底部但是在选项卡上面
             *        
             *          
             */
            if (Array.isArray(cacheComponents) === false) {
                return
            }
            const currentCompId = cacheComponents[index]?.id
            const tabs = cacheComponents.filter(x => x?.cptType === 'combination')

            // 查找子组件是否存在选项卡中
            const hasComponent = this.findCompontentInTab(tabs, currentCompId)
            if (!hasComponent) {
                return false
            }
            // 选项卡边框
            const tabBorderId = hasComponent.tab.group.find(x => x != hasComponent.tab.id)
            // 选项卡边框层级
            const tabBorderIndex = cacheComponents.findIndex(item => item.id === tabBorderId)

            // 组件层级是否小于选项卡
            const isBigIndexTab = index <= (tabBorderIndex - 1)

            if (!isBigIndexTab) {
                return false
            }

            switch (type) {
                case 1://上移
                    if (index === 0) {//已经在最顶层
                        break;
                    }
                    cacheComponents[index] = cacheComponents.splice(index - 1, 1, cacheComponents[index])[0];
                    props.currentCptIndex.value -= 1;
                    break;
                case 2://下移
                    cacheComponents[index] = cacheComponents.splice(index + 1, 1, cacheComponents[index])[0];
                    props.currentCptIndex.value += 1;
                    break;
                case 3://置顶
                    if (index === 0) {//已经在最顶层
                        break;
                    }
                    cacheComponents.unshift(cacheComponents.splice(index, 1)[0]);

                    props.currentCptIndex.value = 0;
                    break;
                case 4://置底
                    // cacheComponents.push(cacheComponents.splice(index, 1)[0]);
                    cacheComponents[index] = cacheComponents.splice(tabBorderIndex - 1, 1, cacheComponents[index])[0];

                    props.currentCptIndex.value = tabBorderIndex - 1
                    break;
            }

            // console.log(type, index, tabBorderIndex, isBigIndexTab, cacheComponents, 'updateLayer')

            contextMenu.show = false
            return true

        }

        /**
         * @title 查找组件是否存在选项卡中
         * @param {Object[]} tabs 
         * @param {String|Number} findId 
         * @returns 
         */
        static findCompontentInTab(tabs, findId) {
            let result = false
            if (Array.isArray(tabs) === false) {
                return result
            }
            tabs.map(tab => {
                for (const key in tab.tabGroup) {
                    let hasComponent = tab.tabGroup[key].some(id => id === findId)
                    if (hasComponent) {
                        result = {
                            tab,
                            tabKey: key
                        }
                    }
                }
            })

            return result
        }
        /**
         * @title 查找组件是否存在选项卡中第几个选项卡
         * @param {Object[]} tabs 
         * @param {String|Number} findId 
         * @returns 
         */
        static findCompontentInTabKey(tabs, findId) {
            let result = false
            if (Array.isArray(tabs) === false) {
                return result
            }
            tabs.map(tab => {
                for (const key in tab?.tabGroup) {
                    let hasComponent = tab.tabGroup[key].some(id => id === findId)
                    if (hasComponent) {
                        result = key
                    }
                }
            })

            return result
        }
        /**
        * 当前组件是否是选项卡
        * @param {*} cacheChoices 
        * @returns 
        */
        static check(cacheChoices) {
            if (cacheChoices === null || cacheChoices === undefined) {
                console.error('cacheChoices is null or undefined');
                return false; // 或者根据你的业务逻辑返回合适的默认值
            }

            // 现在我们可以安全地调用 Object.values()
            const values = Object.values(cacheChoices);
            // 检查所有值是否都通过 ButtonGroup.checkIsButton 的检查
            const isShow = values.some(x => {
                if (x.hasOwnProperty('cptType')) {
                    return x.cptType === 'combination' || x.cptType === 'combination-border'
                } else {
                    return false
                }
            });
            return isShow
        }
        /**
         * @title 获取选项卡当前选中的选项值
         * @param {*} tabTitle 
         * @returns 
         */
        static getCurrentTab(tabTitle) {
            try {
                let dataText = tabTitle.cptOption.cptDataForm.dataText
                if (!dataText) {
                    return '没有选项卡JSON'
                }
                let tabList = JSON.parse(dataText)
                let currentTab = tabList.options[tabTitle.tabIndex]?.value
                if (!currentTab) {
                    return '找不到当前选项卡内容'
                }
                return currentTab
            } catch (error) {
                return error
            }
        }
        /**
         * @title 设置选项卡内容高度
         * @desc 通过清除scaleDiv的高度 将选项卡内容最底部控件的Y轴+高度来设置选项卡内容高度
         * @param {*} current 当前选项卡
         * @param {*} comps 所有组件
         * @returns 
         */
        static setAutoHeight(current, comps, { scale, refMap, setScaleStyleHeight }) {
            let isAutoHeight = current.cptOption.attribute.autoHeight
            if (!isAutoHeight) {
                return
            }
            // 设置动态高度
            let isDesign = location.href.includes('/design')
            if (isDesign) {
                return
            }
            // let scaleDiv = document.querySelector('#scaleDiv')
            let scaleDiv = refMap['scaleDiv']

            // 找不到scaleDiv 
            if (!scaleDiv) {
                return
            }

            // 设置选项卡内容高度
            let tabIndex = current.tabIndex
            let tabCurList = JSON.parse(current.cptOption.cptDataForm.dataText)

            // 当前选项卡value
            let tabCur = tabCurList.options[tabIndex]?.value
            // 当前选项卡组件id
            let tabContentIds = current.tabGroup[tabCur]
            if (!tabContentIds) {
                return
            }
            // 过滤获取当前选项卡组件
            let curContentComps = comps.filter(x => {
                // 不计算父id
                let isFatherId = !x.cptOption.interaction?.fatherGridId
                // console.log(x, 'asdijoasdjoiasdiosijoasdioj');
                // 排除悬浮控件(通过查询gorup中是否有悬浮控件)
                let isFiexdComp = x?.group && comps.find(c => c?.cptType === 'cpt-suspension' && x?.group.includes(c.id))

                // && isFatherId
                return tabContentIds.includes(x.id) && !x.cptOption.attribute?.isTabGroupId && isFatherId && !isFiexdComp
            })
            if (curContentComps.length == 0) {
                return
            }
            // 计算当前选项卡下组件最底部的控件
            let maxYComp = curContentComps.reduce((acc, cur) => {
                let accC = acc.cptY + acc.cptHeight
                let curC = cur.cptY + acc.cptHeight
                return accC >= curC ? acc : cur
            }, curContentComps[0])
            // 计算高度   + 50预留（组件的cptHeight不一定是实际渲染高度）
            let maxHeight = (maxYComp.cptY + maxYComp.cptHeight + 50)

            // console.log(maxHeight,'maxHeight')
            // 是否有悬浮框&&在底部
            let isFiexd = current.cptOption.attribute.isFiexd
            let isFiexdBottom = current.cptOption.attribute.position
            // 将悬浮框的高度加上去 = 预留高度(内容不被遮盖)
            if (isFiexd && isFiexdBottom) {
                // 最大高度 > 视窗 - 悬浮框 是否被遮住
                let isAddHeight = maxHeight > (this.getViewportHeight() - current.cptHeight)
                console.log(isAddHeight, maxHeight, this.getViewportHeight(), (this.getViewportHeight() - current.cptHeight), '去外地及其地位及其定期');
                if (isAddHeight) {
                    // 遮住添加预留区域
                    maxHeight = maxHeight + (current.cptHeight)
                } else {
                    // 当内容小于视窗时 最大高度 / 缩放值 = 整体高度
                    // maxHeight = this.getViewportHeight() / scale.containerScaleX
                }
            }
            // 高度赋值给scaleDiv
            // scaleDiv.style['--height'] = `${maxHeight}px`
            // scaleDiv.setAttribute('data-height',`${maxHeight}px`)
            setScaleStyleHeight(maxHeight)

            console.log(scaleDiv, maxHeight, 'scaleDivscaleDivscaleDiv')
            // 计算当前高度是否大于视窗高度 
            let isScroll = maxHeight > this.getViewportHeight()
            // 设置不滚动
            // scaleDiv.style.overflow = isScroll ? `` : 'hidden'
            scaleDiv.style.overflow = 'hidden'

        }
        /**
         * @title 查询是否是悬浮选项卡关联控件
         * @returns 是关联控件 false : true
         */
        static isGroupComps(item, components) {
            const tabs = components.filter(x => x?.cptType === 'combination' && x.cptOption.attribute.isFiexd)
            const isGroupId = item.cptOption.attribute?.isTabGroupId
            const isHasComp = tabs.some(c => c.id === isGroupId)
            return !isHasComp
        }
        // 获取视窗高度
        static getViewportHeight() {
            var height = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            return height;
        }
        /**
         * @title 禁止删除选项卡关联控件
         */
        static stopTabGroupComps(item, selectComps, components) {
            let { isTabGroupId } = item.cptOption.attribute
            const isTabHandler = item => {
                return item?.cptType === 'combination' && item.id === isTabGroupId
            }
            let isSelectCombinationTab = selectComps.find(isTabHandler)
            let flag = isTabGroupId && !isSelectCombinationTab
            if (flag) {
                MessagePlugin.warning('选项卡模版控件无法删除！')
            }
            return flag
        }
        /**
         * @title 查找选项卡关联边框
         * @param {*} tab 
         * @param {*} components 
         * @returns 
         */
        static getTabBorder(tab, components) {
            if (tab?.cptType !== 'combination') {
                return console.error('getTabBorder的参数不是选项卡')
            }
            let tabGroup = components.find(item => {
                return tab?.group.includes(item.id) && item?.cptType === 'combination-border'
            })

            return tabGroup
        }



    }


    // 九宫格
    class CombinationNg {
        static init(ninegridIds) {
            if (Object.keys(ninegridIds).length == 4) {
                // console.log('hhgg')
                const finddCombinationTab = props.cacheComponents.find(x => x.id === ninegridIds.ngcombination)
                const tabBorder = props.cacheComponents.find(x => x.id === ninegridIds.ngcombinationBorder)
                const tabBordertop = props.cacheComponents.find(x => x.id === ninegridIds.ngcombinationBorderTop)
                const tabBorderbtm = props.cacheComponents.find(x => x.id === ninegridIds.ngcombinationBorderBottom)
                const isGroup = finddCombinationTab?.groupCompName
                // console.log(tabBordertop,'hhgg')
                // console.log(tabBorderbtm,'hhggh')
                // console.log(finddCombinationTab,'hhgghhhh')
                // console.log(tabBorder,'hhgghggg')
                // console.log(!isGroup,'hhgghg')
                if (tabBordertop && tabBorderbtm && finddCombinationTab && tabBorder) {
                    // console.log('tabBordertop')
                    setObj(props.cacheChoices, {
                        [tabBorder.id]: tabBorder,
                        [tabBordertop.id]: tabBordertop,
                        [tabBorderbtm.id]: tabBorderbtm,
                        [finddCombinationTab.id]: finddCombinationTab,
                    })
                    onGroup.init()
                    CombinationNg.setDefaultCombinationTabBorder()
                }
            } else if (Object.keys(ninegridIds).length == 2) {
                const finddCombinationTab = props.cacheComponents.find(x => x.id === ninegridIds.ngcombination)
                const tabBorder = props.cacheComponents.find(x => x.id === ninegridIds.ngcombinationBorder)
                const isGroup = finddCombinationTab?.groupCompName
                if (finddCombinationTab && tabBorder && !isGroup) {
                    setObj(props.cacheChoices, {
                        [tabBorder.id]: tabBorder,
                        [finddCombinationTab.id]: finddCombinationTab,
                    })
                    onGroup.init()
                    CombinationNg.setDefaultCombinationTabBorder()
                    console.log(tabBorder.id, 'tabBorder.idtabBorder.id')
                    finddCombinationTab.tabGroup['index-0'] = [tabBorder.id]
                    finddCombinationTab.cptOption.attribute.cptTabLevel = 1
                }
            }

            // else{
            //     if (finddCombinationTab && tabBorder && !isGroup) {
            //         setObj(props.cacheChoices, {
            //             [tabBorder.id]: tabBorder, 
            //             [finddCombinationTab.id]: finddCombinationTab,
            //         })
            //         onGroup.init()
            //         CombinationNg.setDefaultCombinationTabBorder()
            //     }
            // }

        }
        // 设置九宫格默认边框
        static setDefaultCombinationTabBorder() {
            props.selectedComponents.value.forEach(item => {
                if (item) {
                    item.cptOption.attribute.borderType = 'dv-border-box-0'
                }
            })
        }
        // 组件插入九宫格
        static shiftCombinationComponent(cpt, ev) {
            let tabComps = props.cacheComponents.filter(comp => comp?.cptType == 'ngcombination-border')
            // let tabTitle = props.cacheComponents.find(comp => comp?.cptType == 'combination')
            let cptIndex = props.cacheComponents.findIndex(comp => comp.id == cpt.id)
            if (!tabComps.length) return
            // 
            tabComps.forEach((item) => {
                let findTabTFunc = tabT => tabT.groupCompName === item.groupCompName && tabT?.cptType === 'ngcombination'
                let tabTitle = props.cacheComponents.find(findTabTFunc)
                if (!tabTitle) {
                    return
                }
                // 当选项卡为隐藏不执行操作
                if (tabTitle.cptOption.attribute?.hideCompInTab === true) {
                    return
                }
                // 判断父级id
                const isFatherGridId = item.cptOption.attribute?.fatherGridId
                if (isFatherGridId) {
                    delete item.cptOption.attribute?.fatherTabId
                    return
                }

                if (item.cptOption.attribute.cptDragBorder) {

                    // 当type类型为单个组件时
                    if (ev.type === 'drop') {
                        // 获取触发drop事件的元素（即被拖拽的元素）
                        const draggedElement = ev.target;
                        // 获取被拖拽元素相对于视口的位置
                        const draggedRect = draggedElement.getBoundingClientRect();

                        // 计算左组件 220
                        let containerRectX = (Math.round(draggedRect.left) - 220)
                        // 计算上组件 65
                        let containerRectY = (Math.round(draggedRect.top) - 65)
                        // 目标组件停止覆盖组件 / 缩放
                        let parentOffsetX = Math.round(containerRectX / props.containerScale.value)
                        let parentOffsetY = Math.round(containerRectY / props.containerScale.value)

                        // 目标组件定制覆盖组件 + 当前组件在&的左侧位置
                        cpt.cptX = parentOffsetX + ev.offsetX
                        cpt.cptY = parentOffsetY + ev.offsetY
                    }
                    // let currentTab = this.getCurrentTab(tabTitle)
                    let currentTab = 'index-0'
                    const { cptFatherId } = cpt.cptOption.attribute
                    // 当前有选项卡key和组件没有fatherTabId时添加选项卡子组件
                    if (currentTab && !cptFatherId) {
                        // 给组件添加选项卡id
                        cpt.cptOption.interaction.gridNumber = tabTitle.tabIndex
                        cpt.cptOption.interaction.fatherGridId = tabTitle.id
                        cpt.cptOption.attribute.cptFatherId = tabTitle.id

                        // const newCpt = this.setTabContentIndex({ cpt, tabTitle, currentTab })
                        // console.log(newCpt, 'newCptnewCptnewCpt');
                        // cpt.cptOption.attribute.cptIndex = newCpt?.cptIndex

                        if (tabTitle.tabGroup[currentTab]) {
                            tabTitle.tabGroup[currentTab].push(cpt.id)
                        } else {
                            tabTitle.tabGroup[currentTab] = [cpt.id]
                        }
                    }


                    let nowCpt = props.cacheComponents.splice(cptIndex, 1)[0]
                    props.cacheComponents.unshift(nowCpt)

                    console.log(cpt, 'qdwijqijdiqwdi0qd');
                    this.sortIndex(tabTitle, tabTitle.tabGroup[`index-0`])
                    //判断拖入的是否是子九宫格
                    this.childIndex(tabTitle.tabGroup[`index-0`], 2000000, tabTitle)
                    console.log(cpt, tabTitle, 'qdwijqijd12312312iqwdi0qd');

                }
            })

        }
        // static shiftCombinationComponent(cpt, ev) {
        //     // debugger
        //     let tabComps = props.cacheComponents.filter(comp => comp.cptType == 'ngcombination-border')
        //     // let tabTitle = props.cacheComponents.find(comp => comp.cptType == 'ngcombination')
        //     let cptIndex = props.cacheComponents.findIndex(comp => comp.id == cpt.id)
        //     if (!tabComps.length) return



        //     tabComps.forEach((item) => {
        //         let tabTitle = props.cacheComponents.find(tabT => tabT.groupCompName === item.groupCompName && tabT.cptType === 'ngcombination')
        //         let tabileTarget = props.refMap[tabTitle.id]?.option.attribute.isLock
        //         if (tabileTarget) {
        //             return
        //         }
        //         // 当九宫格在选项卡中隐藏 不添加组件
        //         if (props.refMap[tabTitle.id]?.option.attribute?.hideCompInTab) {
        //             return
        //         }

        //         if (document.getElementById(cpt.id) && document.getElementById(cpt.id).style.display == 'none') {
        //             return
        //         }

        //         // item.option.attribute.fatheerId   -> combination
        //         // let fatherTabId = item.cptOption.attribute?.fatherTabId
        //         // let itemIsTabChild = props.cacheComponents.find(tabItem => tabItem.id == fatherTabId && tabItem.id == 'combination')
        //         // console.log(itemIsTabChild,'itemIsTabChild');
        //         // if(itemIsTabChild) {
        //         //     return 
        //         // }
        //         // if()

        //         // let droppableRect = props.refMap['webContainer'].getBoundingClientRect()
        //         if (item.cptOption.attribute.cptDragBorder) {
        //             // console.log('位置', tabComps, ev)
        //             // console.log(
        //             //     `
        //             //     ${Math.round(ev.offsetX + item.cptX)}
        //             //     ${Math.round(ev.offsetY + item.cptY)}
        //             //     droppableRect: ${droppableRect.left}
        //             //     droppableRect: ${droppableRect.top}
        //             //     `
        //             // )

        //             // 获取触发drop事件的元素（即被拖拽的元素）
        //             const draggedElement = ev.target;
        //             if(!draggedElement) {
        //                 return
        //             }

        //             console.log(ev,ev.target,'evevev');
        //             // 获取被拖拽元素相对于视口的位置
        //             const draggedRect = draggedElement.getBoundingClientRect();

        //             let containerRectX = (Math.round(draggedRect.left) - 220)
        //             let containerRectY = (Math.round(draggedRect.top) - 65)

        //             let parentOffsetX = Math.round(containerRectX / props.containerScale.value)
        //             let parentOffsetY = Math.round(containerRectY / props.containerScale.value)


        //             cpt.cptX = parentOffsetX + ev.offsetX
        //             cpt.cptY = parentOffsetY + ev.offsetY
        //             if (tabTitle.tabGroup[`index-${tabTitle.tabIndex}`]) {
        //                 tabTitle.tabGroup[`index-${tabTitle.tabIndex}`].push(cpt.id)
        //             } else {
        //                 tabTitle.tabGroup[`index-${tabTitle.tabIndex}`] = [cpt.id]
        //             }
        //             cpt.cptOption.interaction.gridNumber = tabTitle.tabIndex
        //             cpt.cptOption.interaction.fatherGridId = tabTitle.id
        //             cpt.cptOption.attribute.cptFatherId = tabTitle.id

        //             // 移形换位
        //             let nowCpt = props.cacheComponents.splice(cptIndex, 1)[0]
        //             props.cacheComponents.unshift(nowCpt)

        //             console.log(cpt,'qdwijqijdiqwdi0qd');
        //             this.sortIndex(tabTitle, tabTitle.tabGroup[`index-${tabTitle.tabIndex}`])
        //             //判断拖入的是否是子九宫格
        //             this.childIndex(tabTitle.tabGroup[`index-0`], 200000, tabTitle)
        //             console.log(cpt,tabTitle,'qdwijqijd12312312iqwdi0qd');

        //         }
        //     })
        // }
        // 大屏中组件添加移除九宫格
        static actionMoveCombiantionComponent(me) {

            // const tabBorder = props.cacheComponents.filter(x =>  x.cptType === 'ngcombination-border')
            const tabTitle = props.cacheComponents.filter(x => x.cptType === 'ngcombination')

            if (!tabTitle) {
                return
            }

            let leftX = ''
            let rightX = ''
            let topY = ''
            let bottomY = ''
            // 过滤组合选项卡
            // let tabCombinationList = props.selectedComponents.value.filter(x => x.cptType != 'ngcombination-border' && x.cptType != 'ngcombination')
            let tabCombinationList = props.selectedComponents.value



            tabCombinationList.forEach(item => {
                // 当组件大于选项卡不执行操作
                tabTitle.forEach(titled => {
                    // console.log(titled, '666666666666666666666666666666666666666666666')

                    let findid = titled.group.find(x => titled.id !== x)
                    var tabBorder = props.cacheComponents.find(x => findid == x.id && x.cptType === 'ngcombination-border')
                    let tabileTarget = props.refMap[titled.id]?.option.attribute.isLock
                    let hideCompInTab = props.refMap[titled.id]?.option.attribute?.hideCompInTab
                    console.log(tabileTarget, 'tabileTargettabileTargettabileTarget')
                    if (tabileTarget) {
                        return
                    }
                    if (hideCompInTab) {
                        return
                    }
                    let docItem = document.getElementById(item.id)
                    if (docItem && docItem.style.display == 'none') {
                        return
                    }

                    if (tabBorder) {
                        leftX = tabBorder?.cptX
                        rightX = tabBorder?.cptX + tabBorder?.cptWidth
                        topY = tabBorder?.cptY
                        bottomY = tabBorder?.cptY + tabBorder?.cptHeight


                        let itemWh = item?.cptWidth + item?.cptHeight
                        let tabBorderWh = tabBorder.cptWidth + tabBorder.cptHeight
                        if (itemWh > tabBorderWh) {
                            return
                        }

                        let itemCompX = item?.cptX + item.cptWidth
                        let itemCompY = item?.cptY + item.cptHeight
                        let isEnter = (itemCompX > leftX && itemCompX < rightX) && (itemCompY > topY && itemCompY < bottomY)
                        if (isEnter) {
                            // if(document.getElementById(tabTitle.id) && document.getElementById(tabTitle.id).style.display == 'none'){
                            //     return 
                            // }
                            const hasComp = CombinationNg.hasCompInTab(titled, item)
                            if (hasComp) {
                                return
                            }
                            let isTabGroup = Array.isArray(titled.tabGroup[`index-0`])
                            // 是否是数组
                            if (isTabGroup) {
                                // console.log(docItem, '添加一个数组组2222件')
                                // 是否有当前组件
                                let isHasComp = titled.tabGroup[`index-0`].includes(item.id)
                                if (isHasComp) {
                                    return
                                }
                                // 判断该元素是否含有 'tab-hide' 类名
                                if (!docItem.classList.contains('tab-hide')) {
                                    // console.log('当前元素不包含 "tab-hide" 类名');

                                    titled.tabGroup[`index-0`].push(item.id)

                                    item.cptOption.interaction.gridNumber = 0
                                    item.cptOption.interaction.fatherGridId = titled.id
                                } else {
                                    // console.log('当前元素包含 "tab-hide" 类名');
                                }

                                // 添加
                            } else {
                                // 当组件是隐藏状态不插入

                                // 添加一个数组组件
                                console.log(docItem, '添加一个数组组件')

                                // 判断该元素是否含有 'tab-hide' 类名
                                if (!docItem.classList.contains('tab-hide')) {
                                    console.log('当前元素不包含 "tab-hide" 类名');

                                    titled.tabGroup[`index-0`] = [item.id]

                                    item.cptOption.interaction.gridNumber = 0
                                    item.cptOption.interaction.fatherGridId = titled.id
                                } else {
                                    console.log('当前元素包含 "tab-hide" 类名');
                                }

                            }
                            // 移形换位
                            // let cptIndex = props.cacheComponents.findIndex(comp => comp.id == item.id)
                            // let nowCpt = props.cacheComponents.splice(cptIndex, 1)[0]
                            // props.cacheComponents.unshift(nowCpt)
                            // console.log(latestFather.getFather(item),'latestFatnerlatestFatner')
                            item.cptOption.attribute.cptFatherId = titled.id
                            this.sortIndex(titled, titled.tabGroup[`index-0`])
                            //判断拖入的是否是子九宫格
                            this.childIndex(titled.tabGroup[`index-0`], 200000, titled)
                        } else {
                            if (titled.tabGroup[`index-0`]?.length > 0 && !titled.group.includes(item.id)) {
                                let removeCompIndex = titled.tabGroup[`index-0`].findIndex(removeId => item.id == removeId)
                                if (removeCompIndex > -1) {
                                    titled.tabGroup[`index-0`].splice(removeCompIndex, 1)
                                    item.cptOption.interaction.gridNumber = ''
                                    item.cptOption.interaction.fatherGridId = ''
                                    if (titled.cptOption.attribute.cptFatherId) {//判断是否有父级，父级是九宫格或者页签
                                        item.cptOption.attribute.cptFatherId = titled.cptOption.attribute.cptFatherId
                                        let father = props.cacheComponents.find((comp) => comp.id == titled.cptOption.attribute.cptFatherId)
                                        if (father.cptType == 'ngcombination') {
                                            this.sortIndex(father, father.tabGroup[`index-0`])
                                        } else if (father.cptType == 'combination') {
                                            CombinationTab.addCompInTabContent(father, item) //调用页签的排列方法
                                        }

                                    } else {
                                        item.cptOption.attribute.cptFatherId = ''
                                    }
                                    //判断移除的是否是子九宫格

                                    this.sortIndex(titled, titled.tabGroup[`index-0`])
                                    this.childIndex(titled.tabGroup[`index-0`], 100000, titled, '移出')
                                }
                            }

                        }



                    }

                })
            })
        }
        static outCpt(ele, father) {
            let titled = father
            let item = ele
            if (titled.tabGroup[`index-0`]?.length > 0 && !titled.group.includes(item.id)) {
                let removeCompIndex = titled.tabGroup[`index-0`].findIndex(removeId => item.id == removeId)
                if (removeCompIndex > -1) {
                    titled.tabGroup[`index-0`].splice(removeCompIndex, 1)
                }
            }
        }
        static inCpt(ele, father) {
            ele.cptOption.attribute.cptFatherId = father.id
            ele.cptOption.interaction.gridNumber = 0

            let isTabGroup = Array.isArray(father.tabGroup[`index-0`])
            // 是否是数组
            if (isTabGroup) {
                // 是否有当前组件
                let isHasComp = father.tabGroup[`index-0`].includes(ele.id)
                if (isHasComp) {
                    return
                }
                father.tabGroup[`index-0`].push(ele.id)
            }
        }

        static inCptForChild(ele, father, selectArr) {

            let isTabGroup = Array.isArray(father.tabGroup[`index-0`])
            // 是否是数组
            if (isTabGroup) {
                // 是否有当前组件
                let isHasComp = father.tabGroup[`index-0`].includes(ele.id)
                if (isHasComp) {
                    return
                }
                father.tabGroup[`index-0`].push(ele.id)
            }
        }
        static actionMoveNg(ele, fatherEle, selectArr) {
            let tabileTarget = fatherEle?.cptOption.attribute?.isLock
            if (tabileTarget) {
                return
            }


            console.log('一次')
            if (ele.cptOption.attribute.cptFatherId) {
                let fatherCpt = props.cacheComponents.find(x => x.id == ele.cptOption.attribute.cptFatherId)
                if (fatherCpt?.cptType == 'combination') {
                    CombinationTab.removeTabInContent(fatherCpt, ele)
                } else if (fatherCpt?.cptType == 'ngcombination') {
                    this.outCpt(ele, fatherCpt)
                }
            }

            if (ele.cptType == 'combination' || ele.cptType == 'ngcombination') {
                //fatherEle父级是九宫格，ele移动的是子九宫格或者子页签
                if (ele.cptOption.attribute.cptFatherId) {
                    let fatherCpt = props.cacheComponents.find(x => x.id == ele.cptOption.attribute.cptFatherId)
                    if (fatherCpt?.cptType == 'combination') {
                        CombinationTab.removeTabInContent(fatherCpt, ele)
                    } else if (fatherCpt?.cptType == 'ngcombination') {
                        console.log('wertwetre345435')
                        this.outCpt(ele, fatherCpt)
                    }

                }


                ele.cptOption.attribute.cptFatherId = fatherEle.id
                // ele.cptOption.interaction.gridNumber = 0
                ele.cptOption.attribute.cptIndex = fatherEle.cptOption.attribute.cptIndex + 1000000
                ele.cptOption.attribute.cptTabLevel = fatherEle.cptOption.attribute.cptTabLevel + 1
                if (ele?.cptType == 'ngcombination') {
                    selectArr.forEach(item => {
                        CombinationNg.inCptForChild(item, fatherEle)
                    })
                    this.sortIndex(ele, ele.tabGroup[`index-0`])
                } else {
                    //调用页签的排列方法
                    selectArr.forEach(item => {
                        CombinationNg.inCptForChild(item, fatherEle)
                    })
                    CombinationTab.setTabContentCompIndex(fatherEle)
                }

            } else {
                //fatherEle父级是九宫格，ele移动的是普通元素
                console.log(fatherEle, 'dnfff')
                CombinationNg.inCpt(ele, fatherEle)
                this.sortIndex(fatherEle, fatherEle.tabGroup[`index-0`])
            }

        }
        static actionMoveNgOut(ele, selectArr) {
            if (ele.cptType == 'combination' || ele.cptType == 'ngcombination') {
                //ele移动的是子九宫格或者子页签
                if (ele.cptOption.attribute.cptFatherId) {
                    let fatherEle = props.cacheComponents.find(item => item.id == ele.cptOption.attribute.cptFatherId)
                    ele.cptOption.attribute.cptFatherId = ''
                    ele.cptOption.attribute.cptIndex = ele.cptOption.attribute.cptIndex - 1000000
                    ele.cptOption.attribute.cptTabLevel = ele.cptOption.attribute.cptTabLevel - 1
                    if (ele.cptType == 'ngcombination') {//ele移动的是子九宫格
                        if (fatherEle.cptType == 'ngcombination') { //父级是九宫格
                            selectArr.forEach(item => {
                                console.log(item, fatherEle, 'oioip')
                                CombinationNg.outCpt(item, fatherEle)
                            })
                            this.sortIndex(ele, ele.tabGroup[`index-0`])
                        }
                    } else {//ele移动的是子页签
                        if (fatherEle.cptType == 'ngcombination') { //父级是九宫格
                            selectArr.forEach(item => {
                                console.log(item, fatherEle, 'oioip')
                                CombinationNg.outCpt(item, fatherEle)
                            })
                        }

                        CombinationTab.setTabContentCompIndex(ele)
                    }
                }


            } else {
                //ele移动的是普通元素
                if (ele.cptOption.attribute.cptFatherId) {
                    let tabTitleItem = props.cacheComponents.find(x => x.id === ele.cptOption.attribute.cptFatherId)
                    if (tabTitleItem?.cptType == 'ngcombination') {
                        ele.cptOption.attribute.cptFatherId = ''
                        ele.cptOption.attribute.cptIndex = ''
                        ele.cptOption.attribute.gridNumber = ''
                        CombinationNg.outCpt(ele, tabTitleItem)
                    } else if (tabTitleItem?.cptType == 'combination') {
                        CombinationTab.removeTabInContent(tabTitleItem, ele)
                    }
                }

                // 这段代码会把其他控件的值也清空掉
                // ele.cptOption.attribute.cptFatherId = ''
                // ele.cptOption.attribute.cptIndex = ''
                // ele.cptOption.attribute.gridNumber = ''
            }
        }

        //设置子九宫格的层级
        static childIndex(group, indexValue, titled, outIn) {

            group.forEach(id => {
                let myitem = props.cacheComponents.find((comp) => comp.id == id)
                if (myitem?.cptType == 'ngcombination') {

                    myitem.cptOption.attribute.cptIndex = indexValue
                    myitem.tabGroup['index-0'].forEach(ids => {
                        let myitems = props.cacheComponents.find((comp) => comp.id == ids)
                        if (myitems) {
                            myitems.cptOption.attribute['cptFatherId'] = myitem.id
                        }

                    })
                    this.sortIndex(myitem, myitem.tabGroup['index-0'])

                } else if (myitem?.cptType == 'combination' || myitem?.cptType == 'combination-border') {
                    if (outIn == '移出') {

                        // CombinationTab.removeTabInContent(titled)
                    } else {

                        if (myitem.cptType == 'combination') {
                            myitem.cptOption.attribute.cptTabLevel = 2
                            myitem.cptOption.attribute.cptIndex = 2100000
                            for (let key in myitem.tabGroup) {
                                myitem.tabGroup[key].forEach(ids => {
                                    let myitems = props.cacheComponents.find((comp) => comp.id == ids)
                                    // myitems.cptOption.attribute.cptFatherId = myitem.id
                                    CombinationTab.addCompInTabContent(myitem, myitems)
                                })
                            }
                        } else {
                            myitem.cptOption.attribute.cptTabLevel = 2
                            myitem.cptOption.attribute.cptIndex = 2000001
                        }


                    }

                }
            })
        }

        //重新排列层级
        static sortIndex(titled, group, isTab) {
            let myIndex = isTab ? 2 : 1
            group?.forEach((findid, index) => {
                let cpt = props.cacheComponents.find(x => findid == x.id)
                // console.log(cpt, cpt.cptOption.attribute.cptFatherId, titled.id, 'qwd9iqwidiq0wjdiwqdji0wqd');
                if (cpt && cpt.cptOption.attribute.cptFatherId == titled.id) {
                    cpt.cptOption.attribute.cptIndex = titled.cptOption.attribute.cptIndex + index + myIndex
                    console.log(cpt.cptOption.attribute.cptIndex);
                }
            })
        }
        //将元素向前移动一位
        static moveForward(arr, element) {
            let index = arr.indexOf(element);
            if (index > 0) {
                arr.splice(index, 1);
                arr.splice(index - 1, 0, element);
            }
            return arr;
        }
        //将元素向后移动一位
        static moveElementForward(arr, element) {
            // console.log(arr, 'dasijadujhaisdidjis');
            let index = arr.indexOf(element);
            if (index >= arr.length - 1) return arr; // 如果已经是最后一个元素，则不移动
            // 将指定索引的元素移除，并将其插入到原位置加一的位置
            arr.splice(index + 1, 0, arr.splice(index, 1)[0]);
            return arr;
        }
        //将元素置开始位置
        static moveElementToTop(arr, element) {
            // 找到元素的索引
            const index = arr.indexOf(element);
            // 如果元素存在于数组中
            if (index > -1) {
                // 移除元素
                arr.splice(index, 1);
                // 将元素插入数组的开始位置
                arr.unshift(element);
            }
            return arr;
        }


        static moveToBottom(arr, item) {
            const index = arr.indexOf(item);
            if (index > -1) {
                arr.splice(index, 1); // 删除元素
                arr.push(item); // 在数组末尾添加元素
            }
        }
        //整层上移
        static layerUp(titled, group) {
            // console.log(titled, group, '整层上移')
            titled.cptOption.attribute.cptIndex = titled.cptOption.attribute.cptIndex + 1000000
            // console.log(titled, 'qwdokqwkdqwodoqwo');
            group?.forEach((findid) => {
                let cpt = props.cacheComponents.find(x => findid == x.id)
                cpt.cptOption.attribute.cptIndex = cpt.cptOption.attribute.cptIndex + 1000000
                console.log(cpt, 'qwdoqwodqwko');
            })
        }
        static layerUpTab(titled, components, type) {
            let border = CombinationTab.getTabBorder(titled, components)

            let index = 0
            if (type === 'increase') {
                index = 1000000
            } else if (type == 'decrease') {
                index = -1000000
            }
            titled.cptOption.attribute.cptIndex = titled.cptOption.attribute.cptIndex + index
            border.cptOption.attribute.cptIndex = border.cptOption.attribute.cptIndex + index

            for (const key in titled.tabGroup) {
                titled.tabGroup[key].forEach(findid => {
                    let cpt = props.cacheComponents.find(x => findid == x.id)
                    cpt.cptOption.attribute.cptIndex = cpt.cptOption.attribute.cptIndex + index
                })
            }
        }

        //整层下移
        static layerDown(titled, group) {
            if (titled.cptOption.attribute.cptIndex <= 1000000) {
                MessagePlugin.warning('已经到最底层')
                return
            }
            titled.cptOption.attribute.cptIndex = titled.cptOption.attribute.cptIndex - 1000000
            group?.forEach((findid) => {
                let cpt = props.cacheComponents.find(x => findid == x.id)
                cpt.cptOption.attribute.cptIndex = cpt.cptOption.attribute.cptIndex - 1000000
            })
        }

        // 选中组合选项卡组件
        static selectMoveCombiantionComp(el) {
            if (!el) {
                return
            }
            let id = el.getAttribute('moveid')
            let tabTitle = props.cacheComponents.find(x => x.id == id && x.cptType === 'ngcombination')
            let tabBorder = props.cacheComponents.find(x => x.id == id && x.cptType === 'ngcombination-border')
            // 如果是组合选项卡头和体 不执行
            if (tabTitle || tabBorder) {
                return
            }
            let selectComp = props.cacheComponents.find(x => x.id == id)
            if (!selectComp) {
                return
            }

            // 点击子组件删除组合选项卡选中
            for (const key in props.cacheChoices) {
                if (props.cacheChoices[key].cptType == 'ngcombination-border'
                    ||
                    props.cacheChoices[key].cptType == 'ngcombination'
                ) {
                    delete props.cacheChoices[key]
                }
            }
        }
        // 当前组件是否存在
        static hasCompInTab(tabTitle, current) {
            let flag = false
            for (const key in tabTitle.tabGroup) {
                tabTitle.tabGroup[key]?.forEach((item, index) => {
                    if (item == current.id) {
                        flag = true
                    }
                })
            }
            return flag
        }
        // 设置拖拽选项卡内边框
        static setCptCompTabBorder({ dragEvent, dragComp, dragStartData }) {

            let tabComps = props.cacheComponents.filter(comp => comp.cptType == "ngcombination-border")

            tabComps.forEach(item => {
                const webContainer = props.refMap['webContainer']
                const componentBar = props.refMap['component-bar']
                const headBar = props.refMap['headBar']
                let boxLeft = webContainer.offsetLeft + componentBar.clientWidth

                let drags = dragEvent.target.clientWidth - dragStartData.x

                let dragX = dragEvent.x - (webContainer.offsetLeft + componentBar.clientWidth)
                let dragY = dragEvent.y - (20 + headBar.$el.clientHeight)

                let dragLx = dragX + (dragEvent.target.clientWidth - dragStartData.x)
                let dragRx = dragX - dragStartData.x

                let dragTx = dragY + (dragEvent.target.clientHeight - dragStartData.y)
                let dragBx = dragY + (dragEvent.target.clientHeight - dragStartData.y) + dragEvent.target.clientHeight

                if (item) {
                    let xEnter = dragLx / props.containerScale.value >= item.cptX
                    let xOut = dragRx / props.containerScale.value < item.cptX + item.cptWidth
                    let yEnter = dragTx / props.containerScale.value >= item.cptY
                    let yOut = dragTx / props.containerScale.value < item.cptY + item.cptHeight

                    item.cptOption.attribute.cptDragBorder = xEnter && xOut && yEnter && yOut
                }
            })


        }


        // 预览中选项卡隐藏显示
        static setPreviewTabContentShowHide(el, refMap) {
            // if (!el) {
            //     return
            // }
            // if (el.current?.cptType === 'ngcombination') {

            //     let tabGroup = el.current?.tabGroup
            //     let tabIndex = el.current?.tabIndex || 0
            //     for (const key in tabGroup) {
            //         tabGroup[key].forEach(x => {
            //             const div = document.getElementById(`div${x}`)
            //             if (!div) {
            //                 return
            //             }
            //             if (`index-0` != key) {
            //                 div.style.display = 'none'
            //                 // div.style.opacity = 0
            //             } else {
            //                 div.style.display = 'block'
            //                 // div.style.opacity = 1
            //             }
            //         })
            //     }
            // }

        }
        // 选中组合选项卡拖拽
        static onTouchCombintionTab(type) {
            const tabTitle = props.selectedComponents.value.find(x => x.cptType === 'ngcombination')
            const tabBorder = props.selectedComponents.value.find(x => x.cptType === 'ngcombination-border')

            if (!tabTitle || !tabBorder) {
                return
            }
            for (const key in tabTitle.tabGroup) {
                tabTitle.tabGroup[key]?.forEach(item => {
                    const findComp = props.cacheComponents.find(x => x.id === item)
                    // const findCompIndex = props.cacheComponents.findIndex(x => x.id === item)
                    if (!tabBorder || !findComp) {
                        return
                    }
                    if (type === 'cancel') {
                        let nowCurrent = props.cacheComponents[props.currentCptIndex.value]
                        if (!nowCurrent) {
                            return
                        }
                        if (nowCurrent?.id != item && item != tabBorder.id) {
                            // props.currentCptIndex.value = null
                            delete props.cacheChoices[item]
                        }
                        // props.currentCptIndex.value = null
                        // 组合选项卡拖拽结束 清楚子组件
                        // if (item != tabTitle.id && item != tabBorder.id) {
                        //     delete props.cacheChoices[item]
                        // }
                        // delete props.cacheChoices[item]
                        console.log(props.cacheChoices, findComp, props.currentCptIndex.value, 'props.cacheChoicesprops.cacheChoices');


                    } else {
                        console.log(findComp, 'findCompfindCompfindComp');
                        props.cacheChoices[item] = findComp
                        props.cacheChoicesFixed[item] = JSON.parse(JSON.stringify(findComp))
                    }

                })
            }

            console.log(props.selectedComponents.value, props.cacheChoices, 'doksaokdaosdods');

        }
        // 批量删除组合选项卡
        // static delete(deleteItem) {
        //     if(deleteItem.cptType == 'ngcombination'){
        //         for (const key in deleteItem.tabGroup) {
        //             deleteItem.tabGroup[key].forEach((id, index) => {
        //                 let cacheCompIndex = props.cacheComponents.findIndex(comp => comp.id == id)
        //                 props.cacheComponents.splice(cacheCompIndex, 1);
        //             })
        //         }
        //         let cacheCompIndex2 = props.cacheComponents.findIndex(comp => comp.id == deleteItem.id)
        //         props.cacheComponents.splice(cacheCompIndex2, 1);

        //     }


        //     let tabComps = props.cacheComponents.filter(x => x.cptType === 'ngcombination' || x.cptType === 'ngcombination-border')

        //     tabComps.forEach(item => {

        //         if (item?.tabGroup) {
        //             for (const key in item.tabGroup) {
        //                 item.tabGroup[key].forEach((id, index) => {
        //                     if (id == deleteItem.id) {
        //                         item.tabGroup[key].splice(index, 1)
        //                         this.sortIndex(item, item.tabGroup[key])
        //                     }
        //                 })
        //             }
        //         }
        //     })
        // }
        // 批量删除组合选项卡
        static delete() {
            let tabComps = props.selectedComponents.value.filter(x => x.cptType === 'ngcombination' || x.cptType === 'ngcombination-border')
            tabComps.forEach(item => {
                if (item?.tabGroup) {
                    for (const key in item.tabGroup) {
                        item.tabGroup[key].forEach(id => {
                            let findComp = props.cacheComponents.find(x => x.id == id)
                            if (findComp) {
                                setObj(props.cacheChoices, { ...props.cacheChoices, [findComp.id]: findComp })
                                setObj(props.cacheChoicesFixed, { ...props.cacheChoicesFixed, [findComp.id]: findComp })
                            }
                        })
                    }
                }
            })
        }
    }
    //找到最近的父级
    class LatestFather {
        static getFather(selectItem, selectArr) {
            // 查找大屏所有组合控件的边框
            const filterTabList = props.cacheComponents.filter(item => {
                let arr = []
                selectArr.forEach(kk => {
                    arr.push(kk.id)
                })
                return (item?.cptType === 'combination-border' || item?.cptType === 'ngcombination-border') && !arr.includes(item.id)
            })

            // 当前组件存在多少内容区中
            const CompInTabList = filterTabList.map(tabBorderItem => {
                // 查找当前内容区域的所有边框
                let tabTitleId = tabBorderItem.group?.filter(x => x !== tabBorderItem.id) || []
                let tabTitleItem = props.cacheComponents.find(x => (x?.cptType === 'combination' && tabTitleId.includes(x.id)) || (x?.cptType === 'ngcombination' && tabTitleId.includes(x.id)))

                let isElement1InElement2 = this.isContained(
                    selectItem.cptX,
                    selectItem.cptY,
                    selectItem.cptWidth,
                    selectItem.cptHeight,
                    tabBorderItem.cptX,
                    tabBorderItem.cptY,
                    tabBorderItem.cptWidth,
                    tabBorderItem.cptHeight,
                )
                return isElement1InElement2 ? tabTitleItem : null
            }).filter(x => x)
            if (CompInTabList.length === 0) {
                return false
            }

            // 查询嵌套内级别最大的选项卡
            const currentInTab = CompInTabList.reduce((accumulator, current) => {
                let currentLevel = current.cptOption.attribute?.cptTabLevel
                let accumulatorLevel = accumulator.cptOption.attribute?.cptTabLevel || 1
                return currentLevel > accumulatorLevel ? current : accumulator
            }, CompInTabList[0])

            return currentInTab
        }
        // 移动组件
        static actionMoveCpt(selectedComponents) {
            console.log('123123213');
            let curSelect = selectedComponents
            // 拖入自己不执行
            if (curSelect.length == 1 && (curSelect[0].cptType == 'ngcombination-border' || curSelect[0].cptType == 'combination-border')) return
            let arr = []
            for (const myItem of curSelect) {
                let myFather = this.getFather(myItem, curSelect)
                if (myFather) {
                    arr.push(myFather)
                }
            }
            // 判断整个选中的所有组件完全移入
            if (arr.length === curSelect.length) {
                // 过滤出九宫格和选项卡组件
                let tabNgArr = curSelect.filter(item => {
                    return item.cptType == 'combination' || item.cptType == 'ngcombination'
                })
                //移动的是九宫格或者页签
                if (tabNgArr.length) {
                    // 查找放入的父级组件
                    let minLevelElement = tabNgArr.reduce((prev, curr) => {
                        return prev.cptOption.attribute.cptTabLevel < curr.cptOption.attribute.cptTabLevel ? prev : curr;
                    }, tabNgArr[0]);
                    // 组件存在父级组件中不执行
                    if (minLevelElement.cptOption.attribute.cptFatherId == arr[0].id) return

                    console.log(minLevelElement, 'minLevelElement');
                    // 
                    if (arr[0].cptType == 'ngcombination') {
                        CombinationNg.actionMoveNg(minLevelElement, arr[0], curSelect)
                    } else if (arr[0].cptType == 'combination') {
                        // console.log('移动选项卡');
                        // console.log(arr[0], tabNgArr, minLevelElement, 'minLevelElement, arr[0]');
                        // let tabBorder = props.cacheComponents(item => item?.cptType === 'combination-border' && minLevelElement.group.includes(item.id))
                        // let tabList = [minLevelElement, ]
                        // CombinationTab.addCompInTabContent(arr[0], minLevelElement)

                    }

                } else {//移动的是普通元素
                    if (arr[0]?.cptType == 'ngcombination') {
                        for (const myItem of curSelect) {
                            CombinationNg.actionMoveNg(myItem, arr[0], curSelect)
                        }
                    } else if (arr[0]?.cptType == 'combination') {
                        // for (const myItem of curSelect) {
                        //     CombinationTab.addCompInTabContent(arr[0], myItem)
                        // }
                        //九宫格嵌套页签，元素直接移到页签里面
                        if (arr[0].cptOption.attribute.cptFatherId) {
                            let ngTitleItem = props.cacheComponents.find(x => (x?.id === arr[0].cptOption.attribute.cptFatherId))
                            if (ngTitleItem.cptType == 'ngcombination') {
                                for (const myItem of curSelect) {
                                    CombinationNg.inCptForChild(myItem, ngTitleItem)
                                }

                            }

                        }
                    }
                }

                //todo 清除tabGroup里面元素的父id和父不相等的元素

            } else {//移出
                this.moveOut(curSelect)
            }
        }
        static moveOut(curSelect) {
            let tabNgArr = curSelect.filter(item => {
                return item.cptType == 'combination' || item.cptType == 'ngcombination'
            })
            if (tabNgArr != 0) {
                let minLevelElement = tabNgArr.reduce((prev, curr) => {
                    return prev.cptOption.attribute.cptTabLevel < curr.cptOption.attribute.cptTabLevel ? prev : curr;
                }, tabNgArr[0]);
                console.log(minLevelElement, 'minLevelElement');
                CombinationNg.actionMoveNgOut(minLevelElement, curSelect)

            } else {
                curSelect.forEach((myItem) => {
                    CombinationNg.actionMoveNgOut(myItem)
                })
            }
        }
        //判断元素2是否包含元素1
        static isContained(x1, y1, width1, height1, x2, y2, width2, height2) {
            // 判断元素1的左上角是否在元素2内
            let topLeft = x1 >= x2 && y1 >= y2;
            // 判断元素1的右下角是否在元素2内
            let bottomRight = (x1 + width1) <= (x2 + width2) && (y1 + height1) <= (y2 + height2);
            // 如果元素1的左上角和右下角都在元素2内，那么元素1就被元素2完全包含
            return topLeft && bottomRight;
        }
    }


    // 按钮组
    class ButtonGroup {
        static MAXENDNUMBER = 4 // 按钮组的最大索引值
        static BUTTONS = [
            {
                type: 0,
                name: '勾选'
            },
            {
                type: 1,
                name: '全选'
            },
            {
                type: 2,
                name: '反选'
            },
            {
                type: 3,
                name: '取消'
            }
        ]
        /**
         * 初始化
         * @param {*} initProps 
         * @returns 
         */
        static init(initProps) {
            // console.log('按钮')
            const { config, cpt } = initProps

            if (config.cptKey === 'cpt-button-group') {

                let buttonTime = +new Date()

                for (let i = 0; i < ButtonGroup.BUTTONS.length; i++) {

                    const button = ButtonGroup.setButton(ButtonGroup.BUTTONS[i], i)

                    props.drop({
                        type: 'HANLERDROP',
                        handler: { ...button, cptX: cpt.cptX, cptY: cpt.cptY, type: `cpt-button-group-${buttonTime}`, index: i }
                    })
                }
                return
            }

            this.createButton(config, cpt)
        }
        /**
         * 将传入的propsButton设置为按钮的名称
         * @param {*} propsButton 
         * @returns 
         */
        static setButton(propsButton, index) {
            // 复制finArrChildrenValue函数返回的数组对象，并将其第一个子组件的'cptKey'属性和'cpt-button'属性传入
            let button = JSON.parse(JSON.stringify(finArrChildrenValue(componentOptions[0].children, 'cptKey', 'cpt-button')))

            // 将按钮的option属性中的cptDataForm属性中的dataText属性设置为一个包含propsButton的name属性值的对象
            button.option.cptDataForm.dataText = `{"value": "${propsButton.name}"}`
            button.option.attribute.buttonGroupType = index
            return button
        }
        /**
         * 创建按钮组
         * @param {*} config 
         * @param {*} cpt 
         */
        static createButton(config, cpt) {
            let isButtonItem = config.type && config.type.includes('cpt-button-group-')
            if (isButtonItem) {
                cpt.cptWidth = 80
                cpt.cptHeight = 30
                let buttonX = config.index > 0 ? (config.index * (cpt.cptWidth + 10)) : 0

                cpt.cptX = config.cptX + buttonX
                cpt.cptY = config.cptY
                // 按钮组生成完成
                const isEnd = (config.index + 1) == ButtonGroup.MAXENDNUMBER
                console.log(isEnd, 'isEnd')
                if (isEnd) {
                    this.deleteParent()
                    this.setSelectCompButtons(cpt)
                }
            }

        }
        /**
         * 清除按钮组控件
         * @desc 此控件当做媒介 不需要存在
         */
        static deleteParent() {
            let parent = props.cacheComponents.findIndex(x => x.cptKey === 'cpt-button-group')
            props.cacheComponents.splice(parent, 1)
            props.outBlur()

        }
        /**
        * 设置选择组件按钮
        * @param {Object} cpt - 组件对象
        */
        static setSelectCompButtons(cpt) {
            let buttons = props.cacheComponents.filter(x => {
                return x?.cptType === cpt?.cptType
            })
            buttons.forEach(x => {
                props.cacheChoices[x.id] = x
                props.cacheChoicesFixed[x.id] = JSON.parse(JSON.stringify(x))
            })
            onGroup.init()
            props.outBlur()

        }
        /**
         * @title 监听按钮组
         */
        static watchButtonGroup(item, comps) {
            console.log(item?.cptType, 'qdokjqwoqdk')
            let isGroupButton = this.checkIsButton(item)
            if (!isGroupButton) {
                return
            }
            console.log(comps)
            let groupButtons = comps.filter(x => x.cptType.includes(isGroupButton.cptType))

            console.log(isGroupButton, groupButtons, 'isGroupButton')
        }
        /**
         * 设置点击按钮的数据 currentCptIndex
         * @param {HTMLElement} el 点击的按钮DOM元素
         */
        static setClickButtonData(el) {
            if (!el || props.cacheComponents.length == 0) {
                return
            }
            let elId = el.getAttribute('moveid')

            let buttons = ButtonGroup.getButtonGroup(elId)
            if (buttons.length === 0) {
                return
            }
            // 通过属性buttonIndex进行降序排序，返回最后一个按钮
            let lastButton = buttons.reduce((n, p) => {
                let nIndex = n.cptShow && n.cptOption.attribute.buttonGroupType
                let pIndex = p.cptShow && p.cptOption.attribute.buttonGroupType
                return nIndex > pIndex ? n : p
            })
            // 在cacheComponents中查找id为lastButton.id的按钮的索引
            let buttonIndex = ButtonGroup.findButtonInCacheComponents('findIndex', props.cacheComponents, lastButton.id)

            props.currentCptIndex.value = buttonIndex


        }
        /**
        * 在缓存组件中查找包含指定元素ID和方法的按钮组件
        * @param {string} method - 方法名
        * @param {string} method[findIndex] - 方法名
        * @param {string} method[find] - 方法名
        * @param {Object} cacheComponents - 缓存组件对象
        * @param {string} elId - 元素ID
        * @returns {Object|null} - 符合条件的组件对象，如果没有找到则返回null
        */
        static findButtonInCacheComponents(method, cacheComponents, elId) {
            return cacheComponents[method]((x) =>
                x.cptKey === 'cpt-button' &&
                x?.cptType?.includes('cpt-button-group-') &&
                x.id === elId
            );
        }
        /**
         * 获取指定id的按钮组
         * @param {*} id 
         * @returns 
         */
        static getButtonGroup(id) {
            return props.cacheComponents.filter(x => {
                // 在缓存组件中查找按钮
                let findButton = ButtonGroup.findButtonInCacheComponents('find', props.cacheComponents, id)
                // 返回组件类型与按钮类型相同的缓存组件
                return x?.cptType === findButton?.cptType
            })
        }
        /**
         * 检查item是否为按钮组组件
         * @param {*} item 
         * @returns Boolean
         */
        static checkIsButton(item) {
            // 检查item.cptType是否存在且包含子字符串'cpt-button-group-'
            return item?.cptType && item?.cptType.includes('cpt-button-group-')
        }
        /**
         * 检查是否包按钮组的含蒙版组件
         * @param {*} item 
         * @returns 
         */
        static checkModelBoxAll(item) {
            let modelBoxArray = ['cpt-tree', 'cpt-ninegrid']
            return modelBoxArray.some(x => x.includes(item.cptKey))
        }
        /**
        * 获取按钮组的选中状态
        * @param {object} item - 按钮组对象
        * @returns {boolean} - 返回是否选中
        */
        static buttonGroupChecked(item) {
            const selectArray = Tools.selectArray()
            if (buttonGroupEventObject.value == null) {
                selectArray && selectArray.forEach(x => {
                    let isEventList = Array.isArray(x?.cptOption.interaction.eventList)
                    if (isEventList) {
                        let eventObj = x?.cptOption.interaction.eventList.find(x => x.buttonGroupActive === "setButtonGroup")
                        if (eventObj) {
                            eventObj.id = eventObj.actionButtonGroupId
                            buttonGroupEventObject.value = eventObj
                        } else {
                            buttonGroupEventObject.value = null
                        }
                    }
                })
            }
            return item?.id == buttonGroupEventObject.value?.id
        }
        /**
         * 目标组件勾选事件(存储目标对象)
         * @param {*} checked 
         * @param {*} event 
         * @param {*} item 
         */
        static buttonGroupSelectedChange(checked, event, item) {
            buttonGroupEventObject.value = checked ? item : false
        }
        /**
         * 目标组件勾选事件绑定
         */
        static onConfirmButtonGroupEvent() {
            const selectArray = Tools.selectArray()

            selectArray.forEach(selectItem => {
                let eventList = Array.isArray(selectItem.cptOption.interaction.eventList)
                if (eventList) {
                    let eventIndex = selectItem.cptOption.interaction.eventList.findIndex(x => x.buttonGroupActive === "setButtonGroup")

                    if (!buttonGroupEventObject.value) {
                        selectItem.cptOption.interaction.eventList.splice(eventIndex, 1)
                    } else {
                        const { cptTitle, id } = buttonGroupEventObject.value
                        let event = {
                            intType: "setButtonGroup", //交互类型
                            intName: "按钮组设置",
                            title: cptTitle,
                            multi: false,
                            actionButtonGroupId: id,
                            activeButtonGroupId: selectItem.id,
                            buttonGroupActive: "setButtonGroup",
                            ID: +new Date()
                        }
                        console.log(eventIndex, event, 'eventIndex')
                        if (eventIndex === -1) {
                            selectItem.cptOption.interaction.eventList.push(event)
                        } else {
                            selectItem.cptOption.interaction.eventList[eventIndex] = event
                        }
                    }
                }
            })


            ButtonGroup.onCancelButtonGroupEvent()
        }
        /**
         * 取消目标事件勾选
         */
        static onCancelButtonGroupEvent() {
            buttonGroupEventObject.value = null
            props.isSetButtonGroup.value = false
        }
        /**
         * 按钮组事件处理
         * @param {*} eventItem 
         * @param {*} refMap 
         */
        static onClickEventPreview(propsData) {
            const { eventItem, refMap } = propsData

            console.log(refMap, refMap[eventItem.actionButtonGroupId], 'buttonbuttonbutton')

            const button = refMap[eventItem.activeButtonGroupId] // 根据activeButtonGroupId获取button组件的引用
            const targetComponent = refMap[eventItem.actionButtonGroupId] // 根据actionButtonGroupId获取目标组件的引用
            const type = button.option.attribute.buttonGroupType // 获取button的buttonGroupType属性值
            if (!targetComponent) {
                return
            }
            switch (targetComponent._.type.name) {
                case 'cpt-ninegrid':
                    // 需要九宫格返回数据
                    ButtonGroup.eventCptNinegridHandlers(targetComponent, type)
                    break;
                case 'cpt-tree':
                    ButtonGroup.eventCptTreeHandlers(targetComponent, type)

                    break;
                default:
                    break;
            }
        }
        /**
         * 处理事件树控件事件
         * @param {Object} target - 目标对象
         * @param {Number} type - 事件类型
         */
        static eventCptTreeHandlers(target, type) {
            if (type === 0) {
                target.option.attribute.checkable = true // 设置可选属性为true
            } else if (type === 1) {
                target.onAllSelect() // 调用全部选择事件处理函数
            } else if (type === 2) {
                target.onSelectInvert() // 调用选择反转事件处理函数
            } else if (type === 3) {
                target.allChecked = [] // 重置全部选中数组为空
                target.option.attribute.checkable = false // 设置不可选
            }
        }
        /**
        * 处理事件九宫格事件
        * @param {Object} target - 目标对象
        * @param {Number} type - 事件类型
        */
        static eventCptNinegridHandlers(target, type) {
            if (type === 0) {
                target.showCheck() // 设置可选属性为true
            } else if (type === 1) {
                target.clickCheck() // 调用全部选择事件处理函数
            } else if (type === 2) {
                target.clickCheckReverse() // 调用全部选择事件处理函数
            } else if (type === 3) {
                target.clickCheckFalse() // 设置不可选
            }
        }
        /**
         * 校验选中的组件是否为按钮组
         * @param {*} cacheChoices 
         * @returns 
         */
        static checkButtonGroup(cacheChoices) {
            if (cacheChoices === null || cacheChoices === undefined) {
                console.error('cacheChoices is null or undefined');
                return false; // 或者根据你的业务逻辑返回合适的默认值
            }

            // 现在我们可以安全地调用 Object.values()
            const values = Object.values(cacheChoices);
            // 检查所有值是否都通过 ButtonGroup.checkIsButton 的检查

            const isShow = values.some(x => ButtonGroup.checkIsButton(x));
            return isShow
        }
        static clearButtonGroupActive() {
            let selectArray = Object.values(props.cacheChoices)
            selectArray.forEach(item => {
                if (item?.cptType && item.cptType.includes('cpt-button-group-') && selectArray.length > 4) {
                    delete props.cacheChoices[item.id]
                }
            })
        }

        /**
         * 按钮组取消拉伸点
         */
        static cancelPositionTag() {
            const selectComps = Object.values(props.cacheChoices)
            let isButtonGroup = selectComps.some(x => x?.cptType && x.cptType.includes('cpt-button-group-'))
            return !isButtonGroup
        }


    }

    // 分页
    class PageComponent {
        /**
         * 选择关联组件
         */
        static changePage(checked, e, item) {
            pageEventObject.value = checked ? item : false
        }
        /**
         * 关联组件默认值
         * @param {*} item 
         * @param {*} currentCpt 
         * @returns 
         */
        static pageDefaultChecked(item, currentCpt) {
            if (pageEventObject.value == null && currentCpt.cptOption) {
                if (Array.isArray(currentCpt.cptOption?.interaction.eventList)) {
                    let event = currentCpt.cptOption?.interaction.eventList.find(x => x.intType === 'setPages')

                    if (event) {
                        event.id = event.activePageId
                        pageEventObject.value = event
                    } else {
                        pageEventObject.value = null
                    }
                }
            }
            return pageEventObject.value?.id == item.id
        }
        /**
         * 设置关联组件
         * @param {*} currentCpt 
         * @param {*} refMap 
         */
        static onConfirmSetPage(currentCpt, refMap) {
            if (!pageEventObject.value) {
                PageComponent.clearEvent(currentCpt)
            } else {
                const { cptTitle, id, cptKey } = pageEventObject.value
                let event = {
                    intType: "setPages", //交互类型
                    intName: "分页组件设置",
                    title: cptTitle,
                    multi: false,
                    activePageId: id,
                    activePageKey: cptKey,
                    ID: +new Date()
                    // tableActive: "setPages"
                }
                let eventIndex = PageComponent.findEventIndex(currentCpt)
                if (eventIndex === -1) {
                    currentCpt.cptOption.interaction.eventList.push(event)
                } else {
                    currentCpt.cptOption.interaction.eventList[eventIndex] = event
                }

                refMap[currentCpt.id].initEventData()
                // 九宫格关联逻辑处理
                if (pageEventObject.value.cptKey === 'cpt-ninegrid') {
                    let pageSizeNum = [4, 6, 9, 12]
                    currentCpt.cptOption.attribute.pageSizeOptions = pageSizeNum.map(x => ({
                        label: `${x} 条/页`,
                        value: x
                    }))
                    currentCpt.cptOption.attribute.autoSwitch_dropdown = false
                    currentCpt.cptOption.attribute.pageSize = 9
                }
            }
            props.isSetPages.value = false
        }
        /**
         * 取消关联组件
         */
        static onCancelSetPage() {
            pageEventObject.value = null
            props.isSetPages.value = false
        }
        /**
         * 删除事件
         * @param {*} currentCpt 
         */
        static clearEvent(currentCpt) {
            const eventIndex = PageComponent.findEventIndex(currentCpt)
            if (eventIndex > -1) {
                currentCpt.cptOption.interaction.eventList.splice(eventIndex, 1)
            }
        }
        /**
         * 查找分页事件索引
         * @param {*} currentCpt 
         * @returns 
         */
        static findEventIndex(currentCpt) {
            return currentCpt.cptOption.interaction.eventList.findIndex(x => x.intType === 'setPages')
        }
        /**
         * 分页执行事件
         * @param {*} param0 
         * @returns 
         */
        static changeEventTargetComponents({ eventItem, option, refMap }) {
            const activePageId = eventItem.activePageId
            if (!activePageId) {
                return
            }
            if (refMap[activePageId]?.pageChange) {
                refMap[activePageId].pageChange(option)
            }
        }

        /**
         * 检查是否包分页的含蒙版组件
         * @param {*} item 
         * @returns 
         */
        static checkModelBoxAll(item) {
            let modelBoxArray = ['cpt-table', 'cpt-ninegrid']
            return modelBoxArray.some(x => x.includes(item.cptKey))
        }

    }


    // 美化
    class HeaderBeautify {
        // 设置自定义模版颜色
        static headerBeautifySet(cptKey, option, id) {
            let theme = HeaderBeautify.listHandler(id)
            try {
                theme.content.forEach(item => {
                    let field = item.field
                    let color = item.color
                    console.log(option, field, color)
                    eval(`option.attribute.${field}=color`)
                })
                return option
            } catch (error) {
                console.log(`美化设置失败: ${error}`)
                return option
            }




        }
        static async list() {
            const { code, data } = await GetBeautify.list()
            if (code !== 200) {
                console.log("error: 获取自定义模版失败")
                return option
            }
            beautifyList.value = data
        }
        static listHandler(id) {
            let themeFunc = id.includes('defaultTheme') ? defaultTheme : beautifyList
            return themeFunc.find(x => x.id == id)
        }
    }


    // 锁定
    const lockVerify = (el) => {
        if (!el) {
            return false
        }
        let isLock = false
        const id = el.getAttribute('moveid')
        props.selectedComponents.value.forEach(item => {
            if (item.id == id) {
                isLock = item.cptLock
            }
        })
        return isLock
    }




    /**
     * 工具
     */
    class Tools {


        static setCacheChoices(cacheChoices) {
            let find = props.cacheComponents.find(x => x.id == cacheChoices.id)
            if (!find) {
                return
            }
            props.cacheChoices[find.id] = find
        }
        static clearCacheChoices() {
            setObj(props.cacheChoices, {})
            setObj(props.cacheChoicesFixed, {})
        }
        static setCacheComponents(cacheComponents) {
            setObj(props.cacheComponents, cacheComponents)
        }
        static selectArray() {
            let selectArray = Object.values(props.cacheChoices)
            if (selectArray.length === 0) {
                return []
            } else {
                return selectArray
            }
        }


    }

    // 文本搜索
    class InputSearchGroup {
        static MAXENDNUMBER = 7 // 按钮组的最大索引值
        static BUTTONS = [
            {
                type: 'cpt-input',
                num: 1,
            },
            {
                type: 'cpt-button',
                num: 0,
            },
            {
                type: 'cpt-text',
                num: 0,
            },
            {
                type: 'cpt-button',
                num: 0,
            },
            {
                type: 'cpt-radio',
                num: 1,
            },
            {
                type: 'cpt-text',
                num: 0,
            },
            {
                type: 'cpt-radio',
                num: 1,
            },

        ]
        /**
         * 初始化
         * @param {*} initProps 
         * @returns 
         */
        static init(initProps) {
            // console.log('文本搜索',initProps)
            const { config, cpt } = initProps
            if (config.cptKey === 'cpt-input-search') {

                let buttonTime = +new Date()

                for (let i = 0; i < InputSearchGroup.BUTTONS.length; i++) {
                    const button = InputSearchGroup.setButton(InputSearchGroup.BUTTONS[i], i)

                    props.drop({
                        type: 'inputsearch',
                        // cptnewtype: button.cptKey === 'cpt-ninegrid' ? 'ngcombination' : undefined,
                        handler: { ...button, cptX: cpt.cptX, cptY: cpt.cptY, typeInputSearch: `cpt-input-search-${buttonTime}`, index: i }
                    })
                }
                return
            }

            this.createButton(config, cpt)
        }
        /**
         * 将传入的propsButton设置为按钮的名称
         * @param {*} propsButton 
         * @returns 
         */
        static setButton(propsButton, index) {
            // 复制finArrChildrenValue函数返回的数组对象，并将其第一个子组件的'cptKey'属性和'cpt-button'属性传入
            const childrenArray = componentOptions[propsButton.num].children;
            let button = JSON.parse(JSON.stringify(finArrChildrenValue(childrenArray, 'cptKey', propsButton.type)));
            // 将按钮的option属性中的cptDataForm属性中的dataText属性设置为一个包含propsButton的name属性值的对象
            // button.option.cptDataForm.dataText = `{"value": "${propsButton.name}"}`
            // console.log(childrenArray,'组件属性')
            if (index == 0) {
                // button.option.cptDataForm.dataText = `{"value": "","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}`
                button.option.attribute.placeholder = '请输入搜索内容';
                button.option.attribute.labelBoolean = false;
                // button.option.attribute.timeIcon = false;
                // button.option.attribute.popupVisible = false;
                // button.option.attribute.label = '';
            } else if (index == 1) {
                button.option.cptDataForm.dataText = `{"value": "搜索"}`;
            } else if (index == 2) {
                button.option.cptDataForm.dataText = `{"value": "历史搜索"}`;
            } else if (index == 3) {
                button.option.cptDataForm.dataText = `{"value": "删除"}`;
            } else if (index == 4) {
                button.option.cptDataForm.dataText = `{"value":"","options":[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]}`;
                button.option.attribute.labelBoolean = false;
            } else if (index == 5) {
                button.option.cptDataForm.dataText = `{"value": "热门搜索"}`;
            } else if (index == 6) {
                button.option.cptDataForm.dataText = `{"value":"","options":[{"label":"选项4","value":"op4"},{"label":"选项5","value":"op5"},{"label":"选项6","value":"op6"}]}`;
                button.option.attribute.labelBoolean = false;
            }
            // let buttonTime = +new Date();
            button.option.attribute.typeInputSearch = `cpt-input-search-${index}`;
            button.option.attribute.buttonGroupType = index;
            return button
        }
        /**
         * 创建按钮组
         * @param {*} config 
         * @param {*} cpt 
         */
        static cptDimensions = {
            'cpt-input': { width: 300, height: 30 },
            'cpt-button': { width: 80, height: 30 },
            'cpt-text': { width: 80, height: 30 },
            'cpt-button': { width: 80, height: 30 },
            'cpt-radio': { width: 80, height: 30 },
            // 'cpt-ninegrid': { width: 380, height: 300 },
            'cpt-text': { width: 80, height: 30 },
            'cpt-radio': { width: 80, height: 30 },
            // 'cpt-ninegrid': { width: 380, height: 300 },

        }
        static createButton(config, cpt) {
            // console.log(config,'config',cpt)
            let isButtonItem = config.typeInputSearch && config.typeInputSearch.includes('cpt-input-search-')
            // console.log(isButtonItem,'isButtonItem')
            if (isButtonItem) {
                if (InputSearchGroup.cptDimensions.hasOwnProperty(cpt.cptKey)) {
                    const dimensions = InputSearchGroup.cptDimensions[cpt.cptKey];
                    cpt.cptWidth = dimensions.width;
                    cpt.cptHeight = dimensions.height;
                }
                // 设置cpt坐标
                let cptX = config.cptX;
                let cptY = config.cptY;

                if (config.index > 0) {
                    switch (config.index) {
                        case 1:
                            cptX += 310; // 直接使用 300 + 10
                            break;
                        case 2:
                            cptY += 40;
                            break;
                        case 3:
                            cptX += 310; // 直接使用 300 + 10
                            cptY += 40;
                            break;
                        case 4:
                            cptY += 80;
                            break;
                        case 5:
                            cptY += 110;
                            break;
                        case 6:
                            cptY += 150;
                            break;
                        default:
                            // 默认情况下cptX和cptY保持不变，因此此处无需任何操作
                            break;
                    }
                }

                // 最终赋值cpt坐标
                cpt.cptX = cptX;
                cpt.cptY = cptY;
                // 按钮组生成完成
                const isEnd = (config.index + 1) == InputSearchGroup.MAXENDNUMBER
                // console.log(cpt,'cpt',isEnd)
                if (isEnd) {
                    this.deleteParent()
                    this.setSelectCompButtons(cpt)
                }
            }
        }
        /**
         * 清除按钮组控件
         * @desc 此控件当做媒介 不需要存在
         */
        static deleteParent() {
            let parent = props.cacheComponents.findIndex(x => x.cptKey === 'cpt-input-search')
            props.cacheComponents.splice(parent, 1)
            props.outBlur()
        }
        /**
        * 设置选择组件按钮
        * @param {Object} cpt - 组件对象
        */
        static setSelectCompButtons(cpt) {
            // console.log(cpt,'cpt',props)
            let buttons = props.cacheComponents.filter(x => {
                return x?.typeInputSearch === cpt?.typeInputSearch
            })
            // console.log(buttons,'buttons')
            buttons.forEach(x => {
                props.cacheChoices[x.id] = x
                props.cacheChoicesFixed[x.id] = JSON.parse(JSON.stringify(x))
            })
            onGroup.init()
            props.outBlur()
            // 默认要组合控件，但是初始化的时候，需要先隐藏，所以需要更改组合控件的属性
            // props.cacheComponents.forEach((component) =>{
            //     if (component.typeInputSearch && component.typeInputSearch !== '' && component.cptKey !== 'cpt-select' && (component.cptKey !== 'cpt-button' || component.cptOption.attribute.buttonGroupType != '1')){
            //         component.cptShow = false;
            //     }  
            // })
        }
        /**
         * 设置点击按钮的数据 currentCptIndex
         * @param {HTMLElement} el 点击的按钮DOM元素
         */
        static setClickButtonData(el) {
            if (!el || props.cacheComponents.length == 0) {
                return
            }
            let elId = el.getAttribute('moveid')

            let buttons = ButtonGroup.getButtonGroup(elId)
            if (buttons.length === 0) {
                return
            }
            // 通过属性buttonIndex进行降序排序，返回最后一个按钮
            let lastButton = buttons.reduce((n, p) => {
                let nIndex = n.cptShow && n.cptOption.attribute.buttonGroupType
                let pIndex = p.cptShow && p.cptOption.attribute.buttonGroupType
                return nIndex > pIndex ? n : p
            })
            // 在cacheComponents中查找id为lastButton.id的按钮的索引
            let buttonIndex = ButtonGroup.findButtonInCacheComponents('findIndex', props.cacheComponents, lastButton.id)

            props.currentCptIndex.value = buttonIndex


        }
        /**
        * 在缓存组件中查找包含指定元素ID和方法的按钮组件
        * @param {string} method - 方法名
        * @param {string} method[findIndex] - 方法名
        * @param {string} method[find] - 方法名
        * @param {Object} cacheComponents - 缓存组件对象
        * @param {string} elId - 元素ID
        * @returns {Object|null} - 符合条件的组件对象，如果没有找到则返回null
        */
        static findButtonInCacheComponents(method, cacheComponents, elId) {
            return cacheComponents[method]((x) =>
                x.cptKey === 'cpt-button' &&
                x?.cptType?.includes('cpt-button-group-') &&
                x.id === elId
            );
        }
        /**
         * 获取指定id的按钮组
         * @param {*} id 
         * @returns 
         */
        static getButtonGroup(id) {
            return props.cacheComponents.filter(x => {
                // 在缓存组件中查找按钮
                let findButton = ButtonGroup.findButtonInCacheComponents('find', props.cacheComponents, id)
                // 返回组件类型与按钮类型相同的缓存组件
                return x?.cptType === findButton?.cptType
            })
        }
        /**
         * 检查item是否为按钮组组件
         * @param {*} item 
         * @returns Boolean
         */
        static checkIsButton(item) {
            // 检查item.cptType是否存在且包含子字符串'cpt-button-group-'
            return item?.cptType && item?.cptType.includes('cpt-button-group-')
        }
        /**
         * 检查是否包按钮组的含蒙版组件
         * @param {*} item 
         * @returns 
         */
        static checkModelBoxAll(item) {
            let modelBoxArray = ['cpt-tree', 'cpt-ninegrid']
            return modelBoxArray.some(x => x.includes(item.cptKey))
        }
        /**
        * 获取按钮组的选中状态
        * @param {object} item - 按钮组对象
        * @returns {boolean} - 返回是否选中
        */
        static buttonGroupChecked(item) {
            const selectArray = Tools.selectArray()
            if (buttonGroupEventObject.value == null) {
                selectArray && selectArray.forEach(x => {
                    let isEventList = Array.isArray(x?.cptOption.interaction.eventList)
                    if (isEventList) {
                        let eventObj = x?.cptOption.interaction.eventList.find(x => x.buttonGroupActive === "setButtonGroup")
                        if (eventObj) {
                            eventObj.id = eventObj.actionButtonGroupId
                            buttonGroupEventObject.value = eventObj
                        } else {
                            buttonGroupEventObject.value = null
                        }
                    }
                })
            }
            return item?.id == buttonGroupEventObject.value?.id
        }
        /**
         * 目标组件勾选事件(存储目标对象)
         * @param {*} checked 
         * @param {*} event 
         * @param {*} item 
         */
        static buttonGroupSelectedChange(checked, event, item) {
            buttonGroupEventObject.value = checked ? item : false
        }
        /**
         * 目标组件勾选事件绑定
         */
        static onConfirmButtonGroupEvent() {
            const selectArray = Tools.selectArray()

            selectArray.forEach(selectItem => {
                let eventList = Array.isArray(selectItem.cptOption.interaction.eventList)
                if (eventList) {
                    let eventIndex = selectItem.cptOption.interaction.eventList.findIndex(x => x.buttonGroupActive === "setButtonGroup")

                    if (!buttonGroupEventObject.value) {
                        selectItem.cptOption.interaction.eventList.splice(eventIndex, 1)
                    } else {
                        const { cptTitle, id } = buttonGroupEventObject.value
                        let event = {
                            intType: "setButtonGroup", //交互类型
                            intName: "按钮组设置",
                            title: cptTitle,
                            multi: false,
                            actionButtonGroupId: id,
                            activeButtonGroupId: selectItem.id,
                            buttonGroupActive: "setButtonGroup",
                            ID: +new Date()
                        }
                        console.log(eventIndex, event, 'eventIndex')
                        if (eventIndex === -1) {
                            selectItem.cptOption.interaction.eventList.push(event)
                        } else {
                            selectItem.cptOption.interaction.eventList[eventIndex] = event
                        }
                    }
                }
            })


            ButtonGroup.onCancelButtonGroupEvent()
        }
        /**
         * 取消目标事件勾选
         */
        static onCancelButtonGroupEvent() {
            buttonGroupEventObject.value = null
            props.isSetButtonGroup.value = false
        }
        /**
         * 按钮组事件处理
         * @param {*} eventItem 
         * @param {*} refMap 
         */
        static onClickEventPreview(propsData) {
            const { eventItem, refMap } = propsData

            const button = refMap[eventItem.activeButtonGroupId] // 根据activeButtonGroupId获取button组件的引用
            const targetComponent = refMap[eventItem.actionButtonGroupId] // 根据actionButtonGroupId获取目标组件的引用
            const type = button.option.attribute.buttonGroupType // 获取button的buttonGroupType属性值
            if (!targetComponent) {
                return
            }
            switch (targetComponent._.type.name) {
                case 'cpt-ninegrid':
                    ButtonGroup.eventCptNinegridHandlers(targetComponent, type)
                    break;
                case 'cpt-tree':
                    ButtonGroup.eventCptTreeHandlers(targetComponent, type)

                    break;
                default:
                    break;
            }
        }
        /**
         * 处理事件树控件事件
         * @param {Object} target - 目标对象
         * @param {Number} type - 事件类型
         */
        static eventCptTreeHandlers(target, type) {
            if (type === 0) {
                target.option.attribute.checkable = true // 设置可选属性为true
            } else if (type === 1) {
                target.onAllSelect() // 调用全部选择事件处理函数
            } else if (type === 2) {
                target.onSelectInvert() // 调用选择反转事件处理函数
            } else if (type === 3) {
                target.allChecked = [] // 重置全部选中数组为空
                target.option.attribute.checkable = false // 设置不可选
            }
        }
        /**
        * 处理事件九宫格事件
        * @param {Object} target - 目标对象
        * @param {Number} type - 事件类型
        */
        static eventCptNinegridHandlers(target, type) {
            if (type === 0) {
                target.showCheck() // 设置可选属性为true
            } else if (type === 1) {
                target.clickCheck() // 调用全部选择事件处理函数
            } else if (type === 2) {
                console.log('反选')
                target.clickCheckReverse() // 调用全部选择事件处理函数
            } else if (type === 3) {
                target.clickCheckFalse() // 设置不可选
            }
        }
        /**
         * 校验选中的组件是否为按钮组
         * @param {*} cacheChoices 
         * @returns 
         */
        static checkButtonGroup(cacheChoices) {
            if (cacheChoices === null || cacheChoices === undefined) {
                console.error('cacheChoices is null or undefined');
                return false; // 或者根据你的业务逻辑返回合适的默认值
            }

            // 现在我们可以安全地调用 Object.values()
            const values = Object.values(cacheChoices);
            // 检查所有值是否都通过 ButtonGroup.checkIsButton 的检查

            const isShow = values.some(x => ButtonGroup.checkIsButton(x));
            return isShow
        }
        // 按钮组限制
        static clearButtonGroupActive() {
            let selectArray = Object.values(props.cacheChoices)
            selectArray.forEach(item => {
                if (item?.cptType && item.cptType.includes('cpt-button-group-') && selectArray.length > 4) {
                    delete props.cacheChoices[item.id]
                }
            })
        }

        /**
         * 按钮组取消拉伸点
         */
        static cancelPositionTag() {
            const selectComps = Object.values(props.cacheChoices)
            let isButtonGroup = selectComps.some(x => x?.cptType && x.cptType.includes('cpt-button-group-'))
            return !isButtonGroup
        }


    }

    // 选择位置 
    class MapPosition {
        static MAXENDNUMBER = 2 // 按钮组的最大索引值
        static BUTTONS = [
            {
                type: 'cpt-choose-place',
                num: 1,
            },
            {
                type: 'cpt-text',
                num: 0,
            },
        ]
        /**
         * 初始化
         * @param {*} initProps 
         * @returns 
         */
        static init(initProps) {
            const { config, cpt } = initProps
            if (config.cptKey === 'cpt-choose-ground') {
                let buttonTime = +new Date()
                for (let i = 0; i < MapPosition.BUTTONS.length; i++) {
                    const button = MapPosition.setButton(MapPosition.BUTTONS[i], i)
                    props.drop({
                        type: 'mapchoose',
                        handler: { ...button, cptX: cpt.cptX, cptY: cpt.cptY, typeInputSearch: `cpt-choose-ground-${buttonTime}`, index: i }
                    })
                }
                return
            }

            this.createButton(config, cpt)
        }
        /**
         * 将传入的propsButton设置为按钮的名称
         * @param {*} propsButton 
         * @returns 
         */
        static setButton(propsButton, index) {
            const childrenArray = componentOptions[propsButton.num].children;
            let button = JSON.parse(JSON.stringify(finArrChildrenValue(childrenArray, 'cptKey', propsButton.type)));
            if (index == 1) {
                button.option.cptDataForm.dataText = `{"value": "114.300663,30.601575"}`;
            }
            button.option.attribute.buttonGroupType = index;
            return button
        }
        /**
         * 创建按钮组
         * @param {*} config 
         * @param {*} cpt 
         */
        static cptDimensions = {
            'cpt-choose-place': { width: 300, height: 40 },
            'cpt-text': { width: 300, height: 40 },
        }
        static createButton(config, cpt) {
            // console.log(config,'config',cpt)
            let isButtonItem = config.typeInputSearch && config.typeInputSearch.includes('cpt-choose-ground-')
            // console.log(isButtonItem,'isButtonItem')
            if (isButtonItem) {
                if (MapPosition.cptDimensions.hasOwnProperty(cpt.cptKey)) {
                    const dimensions = MapPosition.cptDimensions[cpt.cptKey];
                    cpt.cptWidth = dimensions.width;
                    cpt.cptHeight = dimensions.height;
                }
                // 设置cpt坐标
                let cptX = config.cptX;
                let cptY = config.cptY;

                if (config.index > 0) {
                    switch (config.index) {
                        case 1:
                            cptY += 50; // 直接使用 300 + 10
                            break;
                        default:
                            // 默认情况下cptX和cptY保持不变，因此此处无需任何操作
                            break;
                    }
                }

                // 最终赋值cpt坐标
                cpt.cptX = cptX;
                cpt.cptY = cptY;
                // 按钮组生成完成
                const isEnd = (config.index + 1) == MapPosition.MAXENDNUMBER
                // console.log(cpt,'cpt',isEnd)
                if (isEnd) {
                    this.deleteParent()
                    this.setSelectCompButtons(cpt)
                }
            }
        }
        /**
         * 清除按钮组控件
         * @desc 此控件当做媒介 不需要存在
         */
        static deleteParent() {
            let parent = props.cacheComponents.findIndex(x => x.cptKey === 'cpt-choose-ground')
            props.cacheComponents.splice(parent, 1)
            props.outBlur()

        }
        /**
        * 设置选择组件按钮
        * @param {Object} cpt - 组件对象
        */
        static setSelectCompButtons(cpt) {
            // console.log(cpt,'cpt',props)
            let buttons = props.cacheComponents.filter(x => {
                return x?.typeInputSearch === cpt?.typeInputSearch
            })
            // console.log(buttons,'buttons')
            buttons.forEach(x => {
                props.cacheChoices[x.id] = x
                props.cacheChoicesFixed[x.id] = JSON.parse(JSON.stringify(x))
            })
            onGroup.init()
            props.outBlur()

        }
    }
    // 密码
    class PasswordGroup {
        static MAXENDNUMBER = 2 // 按钮组的最大索引值
        static BUTTONS = [
            {
                type: 'cpt-password',
                num: 1,
                label: '新密码'
            },
            {
                type: 'cpt-password',
                num: 1,
                label: '确认密码'
            },
        ]
        /**
         * 初始化
         * @param {*} initProps 
         * @returns 
         */
        static init(initProps) {
            const { config, cpt } = initProps
            if (config.cptKey === 'cpt-password-ground') {
                let buttonTime = +new Date()
                for (let i = 0; i < PasswordGroup.BUTTONS.length; i++) {
                    const button = PasswordGroup.setButton(PasswordGroup.BUTTONS[i], i)
                    // 密码组添加组合类型
                    props.drop({
                        type: 'password',
                        handler: { ...button, cptX: cpt.cptX, cptY: cpt.cptY, type: config.type, typeInputSearch: `cpt-password-ground-${buttonTime}`, index: i }
                    })
                }
                return
            }

            this.createButton(config, cpt)
        }
        /**
         * 将传入的propsButton设置为按钮的名称
         * @param {*} propsButton 
         * @returns 
         */
        static setButton(propsButton, index) {
            const childrenArray = componentOptions[propsButton.num].children;
            let button = JSON.parse(JSON.stringify(finArrChildrenValue(childrenArray, 'cptKey', propsButton.type)));
            button.option.attribute.label = propsButton.label;
            button.option.attribute.placeholder = `请输入${propsButton.label}`
            button.option.attribute.buttonGroupType = index;
            return button
        }
        /**
         * 创建按钮组
         * @param {*} config 
         * @param {*} cpt 
         */
        static cptDimensions = {
            'cpt-password': { width: 300, height: 50 },
            'cpt-password': { width: 300, height: 50 },
        }
        static createButton(config, cpt) {
            // console.log(config,'config',cpt)
            let isButtonItem = config.typeInputSearch && config.typeInputSearch.includes('cpt-password-ground-')
            // console.log(isButtonItem,'isButtonItem')
            if (isButtonItem) {
                if (MapPosition.cptDimensions.hasOwnProperty(cpt.cptKey)) {
                    const dimensions = MapPosition.cptDimensions[cpt.cptKey];
                    cpt.cptWidth = dimensions.width;
                    cpt.cptHeight = dimensions.height;
                }
                // 设置cpt坐标
                let cptX = config.cptX;
                let cptY = config.cptY;

                if (config.index > 0) {
                    switch (config.index) {
                        case 1:
                            cptY += 60;
                            break;
                        default:
                            // 默认情况下cptX和cptY保持不变，因此此处无需任何操作
                            break;
                    }
                }

                // 最终赋值cpt坐标
                cpt.cptX = cptX;
                cpt.cptY = cptY;
                // 按钮组生成完成
                const isEnd = (config.index + 1) == MapPosition.MAXENDNUMBER
                // console.log(cpt,'cpt',isEnd)
                if (isEnd) {
                    this.deleteParent()
                    this.setSelectCompButtons(cpt)
                }
            }
        }
        /**
         * 清除按钮组控件
         * @desc 此控件当做媒介 不需要存在
         */
        static deleteParent() {
            let parent = props.cacheComponents.findIndex(x => x.cptKey === 'cpt-password-ground')
            props.cacheComponents.splice(parent, 1)
            props.outBlur()

        }
        /**
        * 设置选择组件按钮
        * @param {Object} cpt - 组件对象
        */
        static setSelectCompButtons(cpt) {
            // console.log(cpt,'cpt',props)
            let buttons = props.cacheComponents.filter(x => {
                return x?.typeInputSearch === cpt?.typeInputSearch
            })
            // console.log(buttons,'buttons')
            buttons.forEach(x => {
                props.cacheChoices[x.id] = x
                props.cacheChoicesFixed[x.id] = JSON.parse(JSON.stringify(x))
            })
            onGroup.init()
            props.outBlur()

        }
    }


    const init = () => {
        let currentUrl = location.href.includes('/design')
        if (!currentUrl || Object.keys(props).length === 0) {
            return
        }

        // onGroup.watchSelectComps()


        // onMounted(() => {
        // CombinationTab.watchTabTitleIndex()
        // })
        // watch(selectComps, value => {
        //     console.log('watch selectComps')
        //     // for (const key in value) {
        //     //     if (value[key]?.group) {
        //     //         onGroup.clearGroupBorder()
        //     //         onGroup.setGroupBorder()
        //     //     }
        //     // }
        //     onGroup.clearGroupBorder()
        //     onGroup.setGroupBorder()
        // }, { deep: true})


        addDeleteKeyListener()

        watch(() => Object.values(props.cacheChoices), (value) => {
            if (value.length > 1) {
                initLotsizePoistion()
            }
            onGroup.clearGroupBorder()
            onGroup.setGroupBorder()

        }, { deep: true })


        provide('setCompShowHideAll', setCompShowHideAll)
        provide('selectedComponents', props.selectedComponents)
        provide('Tools', Tools)
        provide('Group', onGroup)
        provide('CombinationTab', CombinationTab)
        provide('CombinationNg', CombinationNg)
        provide('LatestFather', LatestFather)
        provide('refMap', props.refMap)
        provide('drop', props.drop)


    }

    init()



    return {
        delCurrCpt,
        setLookHideComp,
        setCompShowHideAll,
        initLookHideComp,
        buttonGroupEventObject,
        pageEventObject,
        clickPoistion,
        onGroup,
        CombinationTab,
        CombinationNg,
        LatestFather,
        ButtonGroup,
        lockVerify,
        Tools,
        HeaderBeautify,
        PageComponent,
        InputSearchGroup,
        MapPosition,
        PasswordGroup
    }
}


